<template>
    <div class="company-details">
        <div class="card">
            <div class="card-body">
                <div class="header-bar">
                    <div class="left-side">
                        <h3>{{companyDetails.companyName}}</h3>
                        <span v-if="companyDetails.disabledAt && companyDetails.disabledAt != null" class="disabled-info">Company disabled: {{companyDetails.disabledAt}}</span>
                    </div>
                    <i @click="backToCompanies" class="fa fa-close"></i>
                </div>
                <div class="upper">
                    <div class="client-settings">
                        <div class="client-settings-buttons-box">
                            <div class="action-buttons-box">
                                <button v-if="otherSettingsEditAccess" @click="goToConfigPlans()" class="btn btn-planconfig">
                                    <i class="fa fa-check-square-o" aria-hidden="true"></i>
                                    Plan config
                                </button>
                                <button v-if="otherSettingsEditAccess" @click="showCarriersModal()" class="btn btn-carriersConfig">
                                    <i class="fa fa-cubes" aria-hidden="true"></i>
                                    Carriers config
                                </button>
                                <button v-if="paySettingsEditAccess" @click="payOption()" class="btn btn-companyconfig">
                                    <i class="fa fa-credit-card" aria-hidden="true"></i>
                                    Pay Option
                                </button>
                                <button v-if="SAColdStockManagement || orderManagementPermission" @click="selectCarrier()" class="btn btn-selectcarrier">
                                    <img :src="require('../../assets/img/coldstock-btn-icon.svg')" alt="Cold stock">
                                    Assign cold stock
                                </button>
                                <button v-if="paySettingsEditAccess && companyDetails.wallet.mode != 'OFFLINE_BILLING'" @click="productPricing()" class="btn btn-productpricing">
                                    <i class="fts-icon-sims"></i>
                                    Product pricing
                                </button>
                                <button v-if="paySettingsEditAccess" @click="showDiscountModal()" class="btn btn-discount">
                                    <i class="fa fa-tag"></i>
                                    Assign discount
                                </button>
                                <button v-if="(companyDetails.wallet.mode == 'HYBRID_TERMS' || companyDetails.wallet.mode == 'PREPAID') && otherSettingsEditAccess" @click="showTopUpModal()" class="btn btn-primary btn-top-up">
                                    <i class="fa fa-usd"></i>
                                    Top Up
                                </button>

                                <button @click="clickAffiliateProgram()" class="btn btn-primary btn-affiliate-program">
                                    <i class="fa fa-pie-chart"></i>
                                    Affiliate Program
                                </button>

                                <button @click="clickMoveSims()" class="btn btn-primary btn-affiliate-program">
                                    <i class="fa fa-arrows"></i>
                                    Move SIMs
                                </button>

                                <div v-if="otherSettingsEditAccess" class="disable-account-box">
                                    <c-switch class="mx-1" color="primary" id="disableAccount" variant="3d" label v-model="companyDetails.disabled" @change.native="disableAccount()"/>
                                    <label for="disableAccount">Disable company</label>
                                </div>
                            </div>
                            <div class="login-button-box">
                                <button @click="loginCompany(companyDetails.companyId, companyDetails.companyName, companyDetails.wallet.mode, companyDetails.hasColdStockAccess, companyDetails.tier2Roaming, companyDetails.voiceAccess, companyDetails.hotSpotAccess, companyDetails.nbIoTPlans, companyDetails.catM1Plans, companyDetails.suspendMRC, companyDetails.displayedCarriers)" class="btn btn-primary btn-login-company">
                                    Login
                                    <i class="fa fa-sign-in"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="allowancesEditAccess" class="allowances">
                        <h3 class="allowances-header">Allowances</h3>
                        <div class="allowances-box">
                            <div class="permission-switch">
                                <c-switch class="mx-1" color="success" id="allowColdStock" variant="3d" label v-model="companyDetails.hasColdStockAccess" @change.native="changePermissions('coldStockAccess')"/>
                                <label for="allowColdStock">Allow adding to cold stock</label>
                            </div>
                            <div v-if="initialSelectedAccountType == 'PREPAID'" class="permission-switch">
                                <c-switch class="mx-1" color="success" id="autoCharge" variant="3d" label v-model="companyDetails.wallet.autoCharge" @change.native="changePermissions('company-auto-charge')"/>
                                <label for="autoCharge">Automatic Payments</label>
                            </div>
                            <div class="permission-switch">
                                <c-switch class="mx-1" color="success" id="excludeNYTax" variant="3d" label v-model="companyDetails.excludeNYTax" @change.native="changeExcludeNYtax()"/>
                                <label for="excludeNYTax">Exclude from NY tax</label>
                            </div>
                            <div class="permission-switch">
                                <c-switch class="mx-1" color="success" id="suspendMRC" variant="3d" label v-model="companyDetails.suspendMRC" @change.native="changeSuspendMRC()"/>
                                <label for="suspendMRC">Suspend MRC</label>
                            </div>
                        </div>
                    </div>
                    <div class="account-details">
                        <div class="account-details-header">
                            <h3>Account Details</h3>
                        </div>
                        <div class="account-details-cell carriers">
                            <h5>Carriers</h5>
                            <strong>{{carriersList}}</strong>
                        </div>
                        <div class="account-details-cell balance">
                            <h5>Balance</h5>
                            <strong v-if="companyDetails.wallet.balance && companyDetails.wallet.balance >= 0"> $ {{companyDetails.wallet.balance}}</strong>
                            <strong v-else-if="companyDetails.wallet.balance && companyDetails.wallet.balance < 0">- $ {{-companyDetails.wallet.balance}}</strong>
                            <strong v-else>--</strong>
                        </div>
                        <div class="account-details-cell last-payment">
                            <h5>Last successful Payment</h5>
                            <strong v-if="companyDetails.lastSuccessfulPaymentAt">{{companyDetails.lastSuccessfulPaymentAt}}</strong>
                            <strong v-else>--</strong>
                        </div>
                        <div class="account-details-cell tac-executed">
                            <h5>Terms and Conditions executed</h5>
                            <strong v-if="companyDetails.hasAgreement">YES</strong>
                            <strong v-else>NO</strong>
                        </div>
                        <div class="account-details-cell account-type">
                            <h5>Account type</h5>
                            <strong v-if="companyDetails.wallet.mode">{{displayedAccountType}}</strong>
                            <strong v-else>--</strong>
                        </div>
                        <div class="account-details-cell discount">
                            <h5>Discount</h5>
                            <strong v-if="discount == 0">No discount</strong>
                            <strong v-else>-{{initialDiscount}}%</strong>
                        </div>
                        <div class="account-details-cell users-number">
                            <h5>Total users</h5>
                            <strong>{{usersNumber}}</strong>
                        </div>
                        <h3 class="affiliate-program-header">Affiliate Program</h3>
                        <div class="affiliate-program-property on-program">
                            <h5>On program</h5>
                            <div v-if="companyDetails.companyAffiliateInfo">
                                <strong v-if="companyDetails.companyAffiliateInfo && companyDetails.companyAffiliateInfo.approvedAffiliate">YES</strong>
                                <strong v-else>NO</strong>
                            </div>
                            <strong v-else>NO</strong>
                        </div>
                        <div class="affiliate-program-property refferals">
                            <h5>Affiliate Program Referrals</h5>
                            <div v-if="companyDetails.companyAffiliateInfo">
                                <strong v-if="companyDetails.companyAffiliateInfo && companyDetails.companyAffiliateInfo.approvedAffiliate">{{companyDetails.companyAffiliateInfo.referrals}}</strong>
                                <strong v-else>--</strong>
                            </div>
                            <strong v-else>--</strong>
                        </div>
                        <div class="affiliate-program-property commision">
                            <h5>Affiliate Commision</h5>
                            <div v-if="companyDetails.companyAffiliateInfo">
                                <strong v-if="companyDetails.companyAffiliateInfo && companyDetails.companyAffiliateInfo.approvedAffiliate">{{companyDetails.companyAffiliateInfo.commission}} %</strong>
                                <strong v-else>--</strong>
                            </div>
                            <strong v-else>--</strong>
                        </div>
                        <div class="company-details-header">
                            <h3>Company Details</h3>
                        </div>
                        <div class="company-details-cell company-address">
                            <h5>Company Address</h5>
                            <div class="company-address" v-if="companyAddressFlag">
                                <strong v-if="companyAddress.addressLine">{{companyAddress.addressLine}},</strong>
                                <strong v-if="companyAddress.addressLine2">{{companyAddress.addressLine2}},</strong>
                                <strong v-if="companyAddress.city">{{companyAddress.city}},</strong>
                                <strong>{{companyAddress.state}} {{companyAddress.postalCode}}, {{companyAddress.country}}</strong>
                            </div>
                            <strong v-else>--</strong>
                        </div>
                        <div class="company-details-cell owner-name">
                            <h5>Owner name</h5>
                            <strong v-if="companyOwner.ownerName">{{companyOwner.ownerName}}</strong>
                            <strong v-else>--</strong>
                        </div>
                        <div class="company-details-cell owner-email">
                            <h5>Owner email</h5>
                            <strong v-if="companyOwner.email">{{companyOwner.email}}</strong>
                            <strong v-else>--</strong>
                        </div>
                        <div class="company-details-cell contact">
                            <h5>Owner contact</h5>
                            <strong v-if="companyOwner.phoneNumber">{{companyOwner.phoneNumber.asString}}</strong>
                            <strong v-else>--</strong>
                        </div>
                        <div class="company-details-cell tax-id">
                            <h5>Tax ID</h5>
                            <strong v-if="companyDetails.taxId">{{companyDetails.taxId}}</strong>
                            <strong v-else>--</strong>
                        </div>
                    </div>
                    <div class="inner-client">
                        <h2>Users</h2>
                        <div class="control-and-legend">
                            <div class="show-disabled">
                                <c-switch v-model="showDisabled" @change.native="getUsersCompany(companyId)" class="mx-1" color="success" variant="pill" label dataOn="✓" dataOff="✕"/>
                                <span class="show-disabled-label">Show disabled users</span>
                            </div>
                            <div class="legend">
                                <div @click="changeRoleFilter(1)" :class="['legend-item', 'admin', filterId == 1 ? 'active' : '']">Admin</div>
                                <div @click="changeRoleFilter(2)" :class="['legend-item', 'provisioning', filterId == 2 ? 'active' : '']">Provisioning</div>
                                <div @click="changeRoleFilter(3)" :class="['legend-item', 'billing', filterId == 3 ? 'active' : '']">Billing</div>
                            </div>
                        </div>
                        <div class="header-list-client">
                            <span>User</span>
                            <span>Role</span>
                            <span>Access to</span>
                        </div>
                        <div v-if="users" class="list-client">
                            <div :class="['item', user.disabled ? 'disabled' : '']" v-for="user in users" v-bind:key="user.userId">
                                <div class="user">
                                    <div class="img-wrap">
                                        <img src="../../assets/img/user-thumbnail.png" alt="" class="light-mode-img">
                                        <img src="../../assets/img/user-thumbnail-dark.png" alt="" class="dark-mode-img">
                                    </div>
                                    <div class="data-wrap">
                                        <strong>{{user.firstName}} {{user.lastName}}</strong>
                                        <span>{{user.email}}</span>
                                    </div>
                                </div>
                                <div class="home-company-role">
                                    <div class="role"><span :class="user.role.roleName">{{user.role.roleName}}</span></div>
                                </div>
                                <div class="companies-roles">
                                    <div v-for="item of user.companyAndRoleInfos" :class="['role', item.roleId == 1 ? 'admin' : '', item.roleId == 2 || item.roleId == 12 ? 'provisioning' : '', item.roleId == 3 || item.roleId == 13  ? 'billing' : '', item.roleId == 9 ? 'customer-owner' : '']"><i v-if="item.isMainCompany" class="fa fa-home"></i>{{item.companyName}}</div>
                                </div>
                                <div v-if="user.role.roleName != 'Customer Owner' && user.disabled == false && user.isMainCompany" class="make-owner-box">
                                    <a class="make-owner" @click="openSetOwnerModal(user.userId, user.firstName, user.lastName)">Set as owner</a>
                                </div>
                            </div>
                        </div>
                        <div class="not-users" v-else>
                            This company don't have any users
                        </div>
                    </div>
                    <div class="fts-table-wrapper audit-log-table">
                        <div class="filter-row">
                            <h3 class="table-title">Company audit log</h3>
                            <div class="filters">
                                <div class="left-side">
                                    <div class="search-box">
                                        <input type="text" id="simManagementSearch" class="form-control" v-model="search" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                                    </div>
                                    <div class="filters-btn-box">
                                        <button class="btn btn-primary filters-btn" @click="filtersClick()">Filters</button>
                                        <div v-if="filtersShown" class="filters-box">
                                            <div class="content-part">
                                                <div class="left-side">
                                                    <h3>Time period</h3>
                                                    <div class="date-pickers-box">
                                                        <div class="date-picker-box">
                                                            <span class="date-label">From</span>
                                                            <date-picker v-model="auditLogsStartDate" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                                                            <span v-if="auditLogsStartDateError != ''" class="error-msg">{{auditLogsStartDateError}}</span>
                                                        </div>
                                                        <div class="date-picker-box">
                                                            <span class="date-label">To</span>
                                                            <date-picker v-model="auditLogsEndDate" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                                                            <span v-if="auditLogsEndDateError != ''" class="error-msg">{{auditLogsEndDateError}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="right-side">
                                                    <div class="header-and-check">
                                                        <h3>Request Type</h3>
                                                        <a v-if="auditLogsFilters.created && auditLogsFilters.pay && auditLogsFilters.carrier && auditLogsFilters.permission && auditLogsFilters.productPricing && auditLogsFilters.disability && auditLogsFilters.discount && auditLogsFilters.planOption && auditLogsFilters.planPricing && auditLogsFilters.SATopUp && auditLogsFilters.customFields && auditLogsFilters.tags && auditLogsFilters.creditCard && auditLogsFilters.manualTopUp && auditLogsFilters.userCreated && auditLogsFilters.userDisabled && auditLogsFilters.userModified" @click="deselectAllFilters()">Unselect all</a>
                                                        <a v-else @click="selectAllFilters()">Select all</a>
                                                    </div>
                                                    <div class="filters-checkboxes">
                                                        <FTScheckbox v-model="auditLogsFilters.created" :label="'Company created'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.pay" :label="'Pay option'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.carrier" :label="'Carrier'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.permission" :label="'Permission'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.productPricing" :label="'Product pricing'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.disability" :label="'Disability'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.discount" :label="'Discount'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.planOption" :label="'Plan Option'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.planPricing" :label="'Plan Pricing'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.SATopUp" :label="'SA Top Up'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.customFields" :label="'Custom Fields'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.tags" :label="'Tag\'s'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.creditCard" :label="'Credit Card'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.manualTopUp" :label="'Manual Top Up'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.userCreated" :label="'User Created'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.userDisabled" :label="'User Disabled'"></FTScheckbox>
                                                        <FTScheckbox v-model="auditLogsFilters.userModified" :label="'User Modified'"></FTScheckbox>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="control-bar">
                                                <div class="left-side">
                                                    <button class="btn btn-light" @click="clearAuditLogsFilters()">Clear All</button>
                                                </div>
                                                <div class="right-side">
                                                    <button class="btn btn-light" @click="cancelAuditLogsFilters()">Cancel</button>
                                                    <button class="btn btn-primary" @click="setAuditLogsFilter()">Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="right-side">
                                    <button class="btn btn-primary export-audit-logs-btn" @click="showExportSelect()">Export Audit Logs</button>
                                    <label for="size-page">Display:</label>
                                    <select id="size-page" v-model="sortSettings.size" @change="getAuditLogs(true)" class="form-control custom-select">
                                        <option value="40" selected>40</option>
                                        <option value="60">60</option>
                                        <option value="80">80</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="fts-table table-responsive-sm">
                            <table class="table b-table table-striped table-condensed table-hover b-table-selectable b-table-select-multi table-managment table-company-log">
                                <thead role="rowgroup">
                                    <tr role="row">
                                        <th @click="changesSort" role="columnheader" aria-colindex="1" aria-sort="descending">Time</th>
                                        <th @click="changesSort" role="columnheader" aria-colindex="3" aria-sort="none">Request Type</th>
                                        <th @click="changesSort" role="columnheader" aria-colindex="7" aria-sort="none">Info</th>
                                        <th @click="changesSort" role="columnheader" aria-colindex="5" aria-sort="none">Original value</th>
                                        <th @click="changesSort" role="columnheader" aria-colindex="6" aria-sort="none">New value</th>
                                        <th @click="changesSort" role="columnheader" aria-colindex="4" aria-sort="none">Modified by</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="log of auditLogs">
                                        <td>{{log.modifiedAt}}</td>
                                        <td>{{log.modificationType.displayName}}</td>
                                        <td>{{log.modificationInfo}}</td>
                                        <td>{{log.stateBefore}}</td>
                                        <td>{{log.stateAfter}}</td>
                                        <td>{{log.modifiedBy}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="fts-bottom-table audit-logs-pagination">
                                <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                                    <Paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></Paginate>
                                </nav>
                            </div>
                        </div>
                        <div class="loader-audit-logs-list" v-if="loading && noLogs == false">
                            <div class="sk-wave">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                            </div>
                        </div>

                        <div class="no-logs" v-if="loading == false && noLogs == true">
                            <h2 class="text">No logs are available for this company</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal size="md" ref="payOptions" id="payOptions" centered hide-footer v-on:trigger:ok="submitChanges()">
            <i class="fa fa-credit-card" aria-hidden="true"></i>

            <h3>Select payment option</h3>
            <h4>Select the way how payment is made</h4>
            <div class="options">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="postPaid" name="payConfig" class="custom-control-input" v-model="selectedAccountType" :checked="selectedAccountType == 'OFFLINE_BILLING'" value="OFFLINE_BILLING"/>
                    <label class="custom-control-label" for="postPaid">Post Paid</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="creditCard" name="payConfig" class="custom-control-input" v-model="selectedAccountType" :checked="selectedAccountType == 'PREPAID'" value="PREPAID"/>
                    <label class="custom-control-label" for="creditCard">Credit Card</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline hybrid-radio">
                    <input type="radio" id="hybrid" name="payConfig" class="custom-control-input" v-model="selectedAccountType" :checked="selectedAccountType == 'HYBRID_TERMS'" value="HYBRID_TERMS"/>
                    <label class="custom-control-label" for="hybrid">Hybrid Terms</label>
                </div>
                <div v-if="selectedAccountType == 'HYBRID_TERMS'" class="hybrid-terms-input-box">
                    <h6>Set Negative Limit</h6>
                    <div class="input-negative-dollars">
                        <span>-$ </span>
                        <input :disabled="selectedAccountType != 'HYBRID_TERMS'" min="0" step="0.01" type="number" v-model="hybridTermsLimit"/>
                    </div>
                    <span v-if="errorPaymentMethod != ''" class="error-payment-method">{{errorPaymentMethod}}</span>
                </div>
            </div>

            <div class="buttons">
                <b-button variant="secondary" @click="closePayModal()">Cancel</b-button>
                <b-button variant="primary" :disabled="(selectedAccountType == initialSelectedAccountType) && (initialSelectedAccountType == 'HYBRID_TERMS' && (hybridTermsLimit == initialHybridTermsLimit))" @click="sendChanesPayModal()">Save</b-button>
            </div>
        </b-modal>

        <b-modal size="md" ref="selectCarrier" id="selectCarrierCompany" class="select-carrier-company" centered hide-footer>
            <i class="fts-icon-sim"></i>

            <strong>Select Carrier</strong>
            <p>Choose a cold stock sim carrier</p>

            <div class="select-carrier-box">
                <div v-if="companyDetails.displayedCarriers.indexOf(1) > -1" @click="showAddColdStock(1)" class="carrier-option" id="simonCarrierSelect">
                    <label for="simon-carrier">
                        <img src="../../assets/img/lightlogo.svg" class="light-version" alt="">
                        <img src="../../assets/img/darklogo.svg" class="dark-version" alt="">
                    </label>
                </div>
                <div v-if="companyDetails.displayedCarriers.indexOf(2) > -1" @click="showAddColdStock(2)" class="carrier-option" id="tmobileCarrierSelect">
                    <label for="t-mobile-carrier">
                        <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                        <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-version">
                    </label>
                </div>
                <div v-if="companyDetails.displayedCarriers.indexOf(3) > -1" @click="showAddColdStock(3)" class="carrier-option" id="vodafoneCarrierSelect">
                    <label for="vodafone-carrier">
                        <img src="../../assets/img/vodafone-logo.svg" alt="" class="light-mode">
                        <img src="../../assets/img/vodafone-logo.svg" alt="" class="dark-version">
                    </label>
                </div>
                <div v-if="companyDetails.displayedCarriers.indexOf(4) > -1" @click="showAddColdStock(4)" class="carrier-option" id="koreCarrierSelect">
                    <label for="kore-carrier">
                        <img src="../../assets/img/kore-logo.svg" alt="" class="light-mode">
                        <img src="../../assets/img/kore-logo.svg" alt="" class="dark-version">
                    </label>
                </div>
            </div>
        </b-modal>

        <b-modal ref="productPricing" id="productPricing" centered hide-footer>
            <img src="../../assets/img/sim-card4.png" alt="">

            <strong>Default item price</strong>
            <p>Enter a new Default price for items (without tax) that a client can order.</p>

            <div v-for="item in itemsList" class="pricing-row">
                <div class="left-side">
                    <img class="carrier-sim" :src="item.cardImage" :alt="item.cardImage">
                    <div class="carrier-logo-box">
                        <img :src="item.lightCarrierImage" :alt="'light logo'" :class="['carrier-logo', 'light-mode', item.carrier.carrierId == 2 ? 'lower' : '']">
                        <img :src="item.darkCarrierImage" :alt="'dark logo'" :class="['carrier-logo', 'dark-mode', item.carrier.carrierId == 2 ? 'lower' : '']">
                    </div>
                </div>
                <div class="pricing-input">
                    <span>$ </span>
                    <input min="0" type="number" @keyup="absValue(item.id)" @change="fixValue(item.id)" step="0.01" v-model="item.unitPrice">
                </div>
            </div>

            <div class="btns-box">
                <button class="btn btn-light" @click="cancelCustomPrices()">Cancel</button>
                <button class="btn btn-success custom-save-btn" :disabled="isPriceChanged()" @click="saveCustomPrices()">Save</button>
            </div>

        </b-modal>

        <b-modal size="md" ref="discountModal" id="discountModal" centered hide-header hide-footer>
            <i @click="cancelDiscount()" class="fa fa-close close-discount-modal"></i>
            <i class="fa fa-tag"></i>

            <strong>Assign discount</strong>
            <p>Select discount for {{companyDetails.companyName}}</p>

            <div class="discounts">
                <div :class="['discount-picker', discount == 0 ? 'picked' : '']" @click="changeDiscountValue(0)">None</div>
                <div :class="['discount-picker', discount == 5 ? 'picked' : '']" @click="changeDiscountValue(5)">-5%</div>
                <div :class="['discount-picker', discount == 10 ? 'picked' : '']" @click="changeDiscountValue(10)">-10%</div>
                <div :class="['discount-picker', discount == 15 ? 'picked' : '']" @click="changeDiscountValue(15)">-15%</div>
                <div :class="['discount-picker', discount == 20 ? 'picked' : '']" @click="changeDiscountValue(20)">-20%</div>
                <div :class="['discount-picker', discount == 25 ? 'picked' : '']" @click="changeDiscountValue(25)">-25%</div>
                <div :class="['discount-picker', discount == 30 ? 'picked' : '']" @click="changeDiscountValue(30)">-30%</div>
                <div :class="['discount-picker', discount == 35 ? 'picked' : '']" @click="changeDiscountValue(35)">-35%</div>
                <div :class="['discount-picker', discount == 40 ? 'picked' : '']" @click="changeDiscountValue(40)">-40%</div>
                <div :class="['discount-picker', discount == 50 ? 'picked' : '']" @click="changeDiscountValue(50)">-50%</div>
            </div>

            <div class="discount-control-bar">
                <button class="btn btn-light" @click="cancelDiscount()">Cancel</button>
                <button class="btn btn-success" :disabled="discount == initialDiscount" @click="saveDiscount()">Assign</button>
            </div>

        </b-modal>


        <b-modal size="md" ref="carrier-config" id="carrierConfig" centered hide-header hide-footer>
            <i @click="revertCarrierConfig()" class="fa fa-close"></i>
            <i class="fa fa-cubes"></i>
            <h3>Allow carriers</h3>
            <h5>Select carriers available for {{companyDetails.companyName}}</h5>
            <div class="carriers-box">
                <div class="carrier-box">
                    <div class="field">
                        <label class="mx-1 switch switch-label switch-3d switch-success form-check-label">
                            <input id="simonCarrierAvailable" type="checkbox" ref="simonCarrierAvailable" v-model="simonCarrierAvailable" :disabled="disallowEditCarrier.existsSimonIot == true && simonCarrierAvailable" @change="changeSimonProperties()" class="switch-input form-check-input" value="true">
                            <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
                        </label>

                        <label for="simonCarrierAvailable">
                            <div :class="['carrier', 'simon', simonCarrierAvailable ? 'selected' : 'not-selected']">
                                <img src="../../assets/img/lightlogo.svg" alt="" class="light-mode">
                                <img src="../../assets/img/simon-carrier-dark.svg" alt="" class="dark-mode">
                            </div>
                        </label>
                    </div>
                    <div class="field">
                        <div :class="['permission-switch', (simonCarrierAvailable == true) ? 'gray-out' : '']">
                            <label class="mx-1 switch switch-label switch-3d switch-success form-check-label">
                                <input id="allowTier2Roaming" type="checkbox" ref="allowTier2Roaming" v-model="simonTier2RoamingAvailable" :disabled="(simonCarrierAvailable == false || (simonTier2RoamingAvailable == true && disallowEditCarrier.existsTier2Roaming == true))" class="switch-input form-check-input" value="true">
                                <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
                            </label>
                            <label for="allowTier2Roaming">Tier International Roaming 2</label>
                        </div>
                    </div>
                    <div class="field">
                        <div :class="['permission-switch', (simonCarrierAvailable == true) ? 'gray-out' : '']">
                            <label class="mx-1 switch switch-label switch-3d switch-success form-check-label">
                                <input id="voiceAccess" type="checkbox" ref="voiceAccess" v-model="voiceAccessAvailable" :disabled="(simonCarrierAvailable == false || (voiceAccessAvailable == true && disallowEditCarrier.existsVoice == true))" class="switch-input form-check-input" value="true">
                                <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
                            </label>
                            <label for="voiceAccess">Voice Access</label>
                        </div>
                    </div>
                    <div class="field">
                        <div :class="['permission-switch', (simonCarrierAvailable == true) ? 'gray-out' : '']">
                            <label class="mx-1 switch switch-label switch-3d switch-success form-check-label">
                                <input id="hotSpotAccess" type="checkbox" ref="hotSpotAccess" v-model="hotSpotAccessAvailable" :disabled="(simonCarrierAvailable == false || (hotSpotAccessAvailable == true && disallowEditCarrier.hasHotSpotPlans == true))" class="switch-input form-check-input" value="true">
                                <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
                            </label>
                            <label for="hotSpotAccess">Hot Spot</label>
                        </div>
                    </div>
                    <div class="field">
                        <div :class="['permission-switch', (simonCarrierAvailable == true) ? 'gray-out' : '']">
                            <label class="mx-1 switch switch-label switch-3d switch-success form-check-label">
                                <input id="initialNBIoT" type="checkbox" ref="initialNBIoT" v-model="NBIoTAvailable" :disabled="(simonCarrierAvailable == false || (NBIoTAvailable == true && disallowEditCarrier.existsNbiot == true))" class="switch-input form-check-input" value="true">
                                <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
                            </label>
                            <label for="initialNBIoT">
                                <div :class="['carrier', 'simon', simonCarrierAvailable ? 'selected' : 'not-selected']">
                                    <img src="../../assets/img/lightlogo.svg" alt="" class="light-mode">
                                    <img src="../../assets/img/simon-carrier-dark.svg" alt="" class="dark-mode">
                                    <span class="nb-iot-label">NB-IOT</span>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="field">
                        <div :class="['permission-switch', (simonCarrierAvailable == true) ? 'gray-out' : '']">
                            <label class="mx-1 switch switch-label switch-3d switch-success form-check-label">
                                <input id="initialCatM1Plans" type="checkbox" ref="initialCatM1Plans" v-model="catM1PlansAvailable" :disabled="(simonCarrierAvailable == false || (catM1PlansAvailable == true && disallowEditCarrier.hasCatPlans == true))" class="switch-input form-check-input" value="true">
                                <span data-checked="On" data-unchecked="Off" class="switch-slider"></span>
                            </label>
                            <label for="initialCatM1Plans">
                                <div :class="['carrier', 'simon', simonCarrierAvailable ? 'selected' : 'not-selected']">
                                    <img src="../../assets/img/lightlogo.svg" alt="" class="light-mode">
                                    <img src="../../assets/img/simon-carrier-dark.svg" alt="" class="dark-mode">
                                    <span class="cat-m1-label">CAT-M1</span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="carrier-box">
                    <div class="field">
                        <c-switch class="mx-1" color="success" id="tmobileCarrierAvailable" :disabled="disallowEditCarrier.existsTMobileSims && tmobileCarrierAvailable" variant="3d" label v-model="tmobileCarrierAvailable" />
                        <label for="tmobileCarrierAvailable">
                            <div :class="['carrier', 't-mobile', tmobileCarrierAvailable ? 'selected' : 'not-selected']">
                                <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                                <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-mode">
                            </div>
                        </label>
                    </div>
                </div>
                <div class="carrier-box">
                    <div class="field">
                        <c-switch class="mx-1" color="success" id="vodafoneCarrierAvailable" :disabled="disallowEditCarrier.existsVodafoneSims && vodafoneCarrierAvailable" variant="3d" label v-model="vodafoneCarrierAvailable" />
                        <label for="vodafoneCarrierAvailable">
                            <div :class="['carrier', 'vodafone', vodafoneCarrierAvailable ? 'selected' : 'not-selected']">
                                <img src="../../assets/img/vodafone-logo.svg" alt="" class="light-mode">
                                <img src="../../assets/img/vodafone-logo.svg" alt="" class="dark-mode">
                            </div>
                        </label>
                    </div>
                </div>
                <div class="carrier-box">
                    <div class="field">
                        <c-switch class="mx-1" color="success" id="koreCarrierAvailable" :disabled="disallowEditCarrier.existsKoreSims && koreCarrierAvailable" variant="3d" label v-model="koreCarrierAvailable" />
                        <label for="koreCarrierAvailable">
                            <div :class="['carrier', 'kore', koreCarrierAvailable ? 'selected' : 'not-selected']">
                                <img src="../../assets/img/kore-logo.svg" alt="" class="light-mode">
                                <img src="../../assets/img/kore-logo.svg" alt="" class="dark-mode">
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="carrier-config-control-bar">
                <button @click="revertCarrierConfig()" class="btn btn-light">Cancel</button>
                <button @click="saveCarrierConfig()" :disabled="simonCarrierAvailable == initialSimonCarrier && tmobileCarrierAvailable == initialTmobileCarrier && vodafoneCarrierAvailable == initialVodafoneCarrier && koreCarrierAvailable == initialKoreCarrier && initialNBIoT == NBIoTAvailable && initialCatM1PlansAvailable == catM1PlansAvailable && simonTier2RoamingAvailable == simonTier2RoamingInitial && voiceAccessAvailable == voiceAccessInitial && hotSpotAccessAvailable == hotSpotAccessInitial" class="btn btn-success">Save</button>
            </div>
        </b-modal>

        <b-modal id="topUpModal" ref="topUpModal" size="md" centered hide-header hide-footer>
            <i class="fa fa-close close-icon" @click="hideTopUpModal()"></i>
            <i class="fa fa-usd top-up-modal-icon"></i>
            <div class="top-up-amount-box">
                <h3>Top Up Client Account</h3>
                <p>Enter Amount which will Top Up the Account</p>
                <input v-model="topUp.amount" class="enter-top-up-amount" type="number" placeholder="Enter $ Amount" :min="topUp.paymentType == 'CHARGE' ? false : 1" step="0.01">
                <span v-if="topUpErrors.amount != ''" class="error-top-up">{{topUpErrors.amount}}</span>
                <span v-if="topUp.paymentType == 'CHARGE' && topUpErrors.amount == ''" class="top-up-hint">To charge customer you need to type negative value</span>
            </div>
            <div class="select-payment-type">
                <h3>Select Payment Type</h3>
                <div class="custom-control-inline">
                    <input type="radio" id="credit" name="payment-type" class="custom-control-input" v-model="topUp.paymentType" :checked="topUp.paymentType == 'CREDIT'" value="CREDIT"/>
                    <label class="custom-control-label" for="credit">Credit</label>
                </div>
                <div class="custom-control-inline">
                    <input type="radio" id="admin-charge" name="payment-type" class="custom-control-input" v-model="topUp.paymentType" :checked="topUp.paymentType == 'CHARGE'" value="CHARGE"/>
                    <label class="custom-control-label" for="admin-charge">Super Admin Charge</label>
                </div>
                <div class="custom-control-inline">
                    <input type="radio" id="cash" name="payment-type" class="custom-control-input" v-model="topUp.paymentType" :checked="topUp.paymentType == 'PAYMENT'" value="PAYMENT"/>
                    <label class="custom-control-label" for="cash">Payment</label>
                </div>
                <select v-model="topUp.paymentSource" :disabled="topUp.paymentType != 'PAYMENT'" class="form-control custom-select">
                    <option :value="'ACH'">ACH</option>
                    <option :value="'WIRE'">Wire</option>
                    <option :value="'CASH'">Cash</option>
                    <option :value="'OTHER'">Other</option>
                </select>
            </div>
            <div class="payment-date">
                <h3>Adjust date Payment was made</h3>
                <date-picker valueType="format" v-model="topUp.paymentDate" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                <span v-if="topUpErrors.date != ''" class="error-top-up">{{topUpErrors.date}}</span>
            </div>
            <div class="control-bar-top-up">
                <button class="btn btn-light" @click="hideTopUpModal()">Cancel</button>
                <button class="btn btn-success" @click="showTopUpConfirmModal()">Top Up</button>
            </div>
        </b-modal>
        <b-modal id="topUpConfirmModal" ref="topUpConfirmModal" size="md" centered hide-header hide-footer>
            <i class="fa fa-close close-icon" @click="hideTopUpConfirmModal()"></i>
            <i class="fa fa-usd top-up-modal-icon"></i>
            <p v-if="topUp.paymentType != 'CHARGE'">{{companyDetails.companyName}} will be topped up with the Amount of <strong>$ {{topUpAmountDisplayed}}</strong></p>
            <p v-else>{{companyDetails.companyName}} will be charged with the Amount of <strong>$ {{topUpAmountDisplayed}}</strong></p>
            <div class="control-bar-confirm-top-up">
                <button class="btn btn-light" @click="hideTopUpConfirmModal()">Cancel</button>
                <button class="btn btn-success" @click="sendTopUp()">Proceed with Top Up</button>
            </div>
        </b-modal>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hideExportSelect()">Cancel</button>
            </div>
        </b-modal>

        <b-modal id="planTypesModal" ref="planTypesModal" size="md" centered hide-header hide-footer>
            <i class="fa fa-close close-icon" @click="hidePlanTypes()"></i>
            <img src="./../../assets/img/simon-logotype-blue.svg" alt="">
            <h3>Plan Type</h3>
            <h4>Allow Plan Type</h4>
            <div class="plan-types">
                <label for="planTypeFlex" class="disabled">
                    <input checked disabled id="planTypeFlex" type="checkbox">
                    <span class="checkbox-check"></span>
                    <div class="plan-type">
                        Simon Flex
                    </div>
                </label>
                <label for="planTypeNB">
                    <input :checked="initialNBIoT" v-model="initialNBIoT" id="planTypeNB" type="checkbox"/>
                    <span class="checkbox-check"></span>
                    <div class="plan-type">
                        Simon NB
                    </div>
                </label>
            </div>
            <div class="buttons-row">
                <button class="btn btn-light" @click="hidePlanTypes()">Cancel</button>
                <button class="btn btn-success" v-bind:disabled="initialNBIoT == companyDetails.nbIoTPlans" @click="savePlanTypes()">Save</button>
            </div>
        </b-modal>

        <b-modal id="affiliateProgram" ref="affiliateProgram" size="md" centered hide-header hide-footer>
            <i class="fa fa-close close-icon" @click="hideAffiliateProgramModal()"></i>
            <i class="fa fa-pie-chart"></i>
            <h3>Affiliate Program</h3>
            <p>To make the user a program member, you need to set the program allowance to ON, and select the commision rate. It's 5% by default.</p>
            <div class="switch-row">
                <c-switch class="mx-1" color="success" variant="3d" id="allowAffiliate" label v-model="companyDetails.companyAffiliateInfo.approvedAffiliate" @change.native="changeAffiliate()"></c-switch>
                <label for="allowAffiliate">Allow use of program</label>
            </div>
            <div class="commision">
                <h3>Commision</h3>
                <p>Set Commision rate for Referal Agent</p>
                <div class="rates-box">
                    <div @click="selectCommisionValue(5)" :class="['rate', commisionSelected == 5 ? 'selected' : '']">5%</div>
                    <div @click="selectCommisionValue(8)" :class="['rate', commisionSelected == 8 ? 'selected' : '']">8%</div>
                    <div @click="selectCommisionValue(10)" :class="['rate', commisionSelected == 10 ? 'selected' : '']">10%</div>
                    <div @click="selectCommisionValue(12)" :class="['rate', commisionSelected == 12 ? 'selected' : '']">12%</div>
                    <div @click="selectCommisionValue(15)" :class="['rate', commisionSelected == 15 ? 'selected' : '']">15%</div>
                </div>
            </div>
            <div class="control-row">
                <button class="btn btn-light" @click="hideAffiliateProgramModal()">Cancel</button>
                <button class="btn btn-success" :disabled="companyDetails.companyAffiliateInfo.approvedAffiliate == false" @click="saveAffiliateProgram()">Activate</button>
            </div>
        </b-modal>

        <AffiliateProgram v-if="openAffiliateWindow" @triggerClose="openAffiliateWindow = false" @affiliateDisabled="companyDetails.companyAffiliateInfo.approvedAffiliate = false" :companyIdProp="companyId" :superAdminProp="true" :companyNameProp="companyDetails.companyName"></AffiliateProgram>

        <b-modal size="md" ref="ownerConfirm" id="ownerConfirm" centered hide-footer hide-header>
            <i @click="closeSetOwnerModal()" class="fa fa-close"></i>
            <img src="../../assets/img/user-icon-hover.svg" alt="">
            <h3>Set New Owner</h3>
            <p>{{newOwner.firstName}} {{newOwner.lastName}} role will be changed to Owner. The Current Owner {{currentOwner.firstName}} {{currentOwner.lastName}} role will be set to Admin.</p>
            <div class="buttons-row">
                <button @click="closeSetOwnerModal()" class="btn btn-light">Cancel</button>
                <button @click="setAsOwner()" class="btn btn-success">Confirm</button>
            </div>
        </b-modal>

        <ColdStock v-if="coldStock" :closeModal="closeColdStock" :carrierId="carrierId" :companyId='companyId' :addToCompany="true"></ColdStock>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from './../../variables'
import ColdStock from "../fulfilment/ColdStock";
import AffiliateProgram from "../admin/AffiliateProgram";
import { Switch as cSwitch } from "@coreui/vue";
import VueCookies from 'vue-cookies';
import DatePicker from 'vue2-datepicker'
import Paginate from 'vuejs-paginate'
import FTScheckbox from "../../ftsComponents/FTScheckbox";

Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)


export default {
    name: 'CompanyDetails',
    components: {
        FTScheckbox,
        ColdStock: ColdStock,
        AffiliateProgram: AffiliateProgram,
        cSwitch,
        DatePicker,
        Paginate
    },
    data() {
        return {
            disallowEditCarrier: [],
            simonTier2RoamingAvailable: false,
            simonTier2RoamingInitial: false,
            voiceAccessAvailable: false,
            hotSpotAccessAvailable: false,
            voiceAccessInitial: false,
            hotSpotAccessInitial: false,
            NBIoTAvailable: false,
            catM1PlansAvailable: false,
            voiceAccess: false,
            filter: null,
            users: null,
            usersNumber: null,
            companyId: this.$route.params.id,
            companyAddressFlag: false,
            companyAddress: {
                city: '',
                postalCode: '',
                country: '',
                phoneNumber: '',
                state: '',
                defaultAddress: '',
                address1: '',
                address2: ''
            },
            companyOwner: {
                ownerName: '',
                email: '',
                phoneNumber: ''
            },
            companyDetails: {
                companyName: '',
                companyId: this.$route.params['id'],
                disabled: false,
                address:
                    {
                        city: '',
                        postalCode: '',
                        country: '',
                        phoneNumber: {
                          number:'',
                          dialCode:'',
                          asString:''
                        },
                        state: '',
                        defaultAddress: '',
                        address1: '',
                        address2: ''
                    },
                owner: [
                    {
                        ownerName: '',
                        email: '',
                        phoneNumber: '',
                        defaultOwner: ''
                    }
                ],
                wallet: {
                    mode: ''
                },
                hasColdStockAccess: false,
                tier2Roaming: false,
                voiceAccess: false,
                hotSpotAccess: false,
                nbIoTPlans: false,
                catM1Plans: false,
                displayedCarriers: [],
                companyAffiliateInfo: {
                    approvedAffiliate: false
                },
                excludeNYTax: false,
                suspendMRC: false
            },
            carrierId: 0,
            coldStock: false,
            clodStockBlock: 0,
            discount: 0,
            initialDiscount: 0,
            simonCarrierAvailable: false,
            tmobileCarrierAvailable: false,
            vodafoneCarrierAvailable: false,
            koreCarrierAvailable: false,
            initialSimonCarrier: false,
            initialTmobileCarrier: false,
            initialVodafoneCarrier: false,
            initialKoreCarrier: false,
            itemsList: [],
            initialPrices: [],
            carriersList: '',
            initialNBIoT: false,
            initialCatM1PlansAvailable: false,
            tempVaraiables: false,
            hybridTermsLimit: null,
            selectedAccountType: null,
            initialSelectedAccountType: null,
            initialHybridTermsLimit: null,
            langDataPicker: {
                days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                placeholder: {
                    date: 'Select Date',
                    dateRange: 'Select Date'
                }
            },
            topUp: {
                amount: null,
                paymentType: 'PAYMENT',
                paymentDate: null,
                paymentSource: 'ACH'
            },
            topUpErrors: {
                amount: '',
                date: ''
            },
            topUpAmountDisplayed: '',
            displayedAccountType: '',
            errorPaymentMethod: '',
            allowancesEditAccess: false,
            paySettingsEditAccess: false,
            otherSettingsEditAccess: false,
            SAColdStockManagement: false,
            orderManagementPermission: false,
            auditLogs: [],
            sortSettings: {
                size: 40,
                page: 1,
                sort: 1,
                desc: true
            },
            paginationCount: 0,
            loading: false,
            noLogs: false,
            searchString: '',
            search: '',
            typingTimer: null,
            filtersShown: false,
            auditLogsFilters: {
                created: false,
                pay: false,
                carrier: false,
                permission: false,
                productPricing: false,
                disability: false,
                discount: false,
                planOption: false,
                planPricing: false,
                SATopUp: false,
                customFields: false,
                tags: false,
                creditCard: false,
                manualTopUp: false,
                userCreated: false,
                userDisabled: false,
                userModified: false
            },
            auditLogsStartDate: '',
            auditLogsEndDate: '',
            filterQuery: '',
            auditLogsStartDateError: '',
            auditLogsEndDateError: '',
            initialAuditLogsFilters: {
                created: false,
                pay: false,
                carrier: false,
                permission: false,
                productPricing: false,
                disability: false,
                discount: false,
                planOption: false,
                planPricing: false,
                SATopUp: false,
                customFields: false,
                tags: false,
                creditCard: false,
                manualTopUp: false,
                userCreated: false,
                userDisabled: false,
                userModified: false
            },
            initialAuditLogsStartDate: '',
            initialAuditLogsEndDate: '',
            openAffiliateWindow: false,
            commisionSelected: 5,
            newOwner: {
                firstName: null,
                lastName: null
            },
            currentOwner: {
                firstName: null,
                lastName: null
            },
            newOwnerId: null,
            showDisabled: false,
            filterId: false
        }
    },
    methods: {
        changeSimonProperties() {
            if (this.simonCarrierAvailable == false) {
                if (this.simonTier2RoamingAvailable == true) {
                    this.$refs.allowTier2Roaming.click();
                }
                if (this.voiceAccessAvailable == true) {
                    this.$refs.voiceAccess.click();
                }
                if (this.NBIoTAvailable == true) {
                    this.$refs.initialNBIoT.click();
                }
            }

            if (this.companyDetails.displayedCarriers.indexOf(1) > -1 && this.simonCarrierAvailable == true) {
                this.voiceAccess = false;
            } else if (this.companyDetails.displayedCarriers.indexOf(1) == -1 && this.simonCarrierAvailable == false) {
                this.voiceAccess = true;
            } else if (this.companyDetails.displayedCarriers.indexOf(1) == -1 && this.simonCarrierAvailable == false) {
                this.voiceAccess = true;
            }
        },
        changePermissions(perm) {
            let status = null;
            if (perm == 'coldStockAccess') {
                status = this.companyDetails.hasColdStockAccess
            } else if (perm == 'tier2Roaming') {
                status = this.companyDetails.tier2Roaming
            } else if (perm == 'voice-plans-access') {
                status = this.companyDetails.voiceAccess
            } else if (perm == 'company-auto-charge') {
                status = this.companyDetails.wallet.autoCharge
            }

            Axios.patch(`${globalStore.data.restApiUrl}/admin/accounts/${perm}/${status}?companyId=${this.companyId}`)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Update company success',
                        text: 'Permissions settings Updated Successfully',
                        duration: 5000,
                    });
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Update company error',
                        text: 'Error Updating Permissions - Contact Support',
                        duration: 5000,
                    });
                    return false;
                })
        },
        changeExcludeNYtax() {
            Axios.patch(globalStore.data.restApiUrl + '/admin/accounts/sales-tax-exempt/' + this.companyDetails.excludeNYTax + '?companyId=' + this.companyId)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'NY Tax settings updated',
                        text: 'Tax settings Updated Successfully',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'NY Tax settings not updated',
                        text: 'Updating Tax settings Error',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        changeSuspendMRC() {
            Axios.patch(globalStore.data.restApiUrl + '/admin/accounts/netcracker-suspend-mrc/' + this.companyDetails.suspendMRC + '?companyId=' + this.companyId)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Suspend MRC settings updated',
                        text: 'Suspend MRC Updated Successfully',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Suspend MRC settings not updated',
                        text: 'Suspend MRC settings Error',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        sendChanesPayModal() {
            this.errorPaymentMethod = ''
            let updatedCompanyData = {
                mode: this.selectedAccountType
            }
            if (this.selectedAccountType == 'HYBRID_TERMS') {
                updatedCompanyData.hybridLimit = -Math.abs(this.hybridTermsLimit);
                if (updatedCompanyData.hybridLimit >= 0) {
                    this.errorPaymentMethod = 'Please set correct limit value.'
                    return false
                }
            }
            Axios.patch(globalStore.data.restApiUrl + '/admin/accounts/wallet?companyId=' + this.companyId, updatedCompanyData)
                .then(response => {
                    if (response.status == 200) {
                        this.companyDetails.wallet.mode = this.selectedAccountType;

                        if (this.companyDetails.wallet.mode == 'PREPAID') {
                            this.displayedAccountType = 'Prepaid'
                        } else if (this.companyDetails.wallet.mode == 'OFFLINE_BILLING') {
                            this.displayedAccountType = 'Offline Billing'
                        } else if (this.companyDetails.wallet.mode == 'HYBRID_TERMS') {
                            this.displayedAccountType = 'Hybrid Terms'
                            this.initialHybridTermsLimit = this.hybridTermsLimit
                        }

                        this.initialSelectedAccountType = this.selectedAccountType

                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Update company success',
                            text: 'Company Details Updated Successfully',
                            duration: 5000,
                        });
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Update company error',
                            text: 'Error Updating Company Details - Contact Support',
                            duration: 5000,
                        });
                        return false;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Update company error',
                        text: 'Error Updating Company Details - Contact Support',
                        duration: 5000,
                    });
                    return false;
                })
            this.$refs['payOptions'].hide()
        },
        closePayModal() {
            if (this.initialSelectedAccountType != this.selectedAccountType) {
                this.selectedAccountType = this.initialSelectedAccountType
                if (this.initialSelectedAccountType == 'HYBRID_TERMS') {
                    this.hybridTermsLimit = this.initialHybridTermsLimit
                }
            }
            this.$refs['payOptions'].hide()
        },
        payOption() {
            this.$refs['payOptions'].show()
            this.initialSelectedAccountType = this.selectedAccountType
            if (this.initialSelectedAccountType == 'HYBRID_TERMS') {
                this.initialHybridTermsLimit = this.hybridTermsLimit
            }
        },
        closeColdStock(){
            this.coldStock = false;
        },
        validatedCount(value) {
            this.coldStockValidated = value;
        },
        changeRoleFilter(id) {
            if (this.filterId == id) {
                this.filterId = false
            } else {
                this.filterId = id
            }
            this.getUsersCompany(this.companyId)
        },
        getUsersCompany(id) {
            let filter = ''
            if (this.filterId) {
                filter = '&roleId=' + this.filterId
            }
            Axios.get(globalStore.data.restApiUrl + `/account/users?companyId=${id}&showDisabled=${this.showDisabled}${filter}` )
                .then(response => {
                    this.users = response.data;
                    this.usersNumber = this.users.length;
                    for (let user of this.users) {
                        if (user.role.roleName == 'Customer Owner') {
                            this.currentOwner.firstName = user.firstName
                            this.currentOwner.lastName = user.lastName
                        }
                        user.isMainCompany = false
                        if (user.companyAndRoleInfos) {
                            for (let item of user.companyAndRoleInfos) {
                                if (item.companyId == id && item.isMainCompany) {
                                    user.isMainCompany = true
                                }
                            }
                        }
                    }
                });
        },
        goToConfigPlans() {
            this.$router.push(`/admin/company/${this.companyId}/plans`);
        },
        getCompanyDetails(id) {
            Axios.get(`${globalStore.data.restApiUrl}/account/admin-view?companyId=${id}`)
                .then(response => {
                    this.companyDetails = response.data;
                    if (this.companyDetails.owners.length > 0) {
                        this.companyOwner = this.companyDetails.owners[0]
                    }

                    if (this.companyDetails.addresses.length > 0) {
                        this.companyAddressFlag = true;

                        this.companyAddress = this.companyDetails.addresses[0]
                    }

                    this.carriersList = [];

                    for (let carrier of this.companyDetails.displayedCarriers) {
                        if (carrier == 1) {
                            this.carriersList.push('SimonIoT')
                        } else if (carrier == 2) {
                            this.carriersList.push('T-Mobile')
                        } else if (carrier == 3) {
                            this.carriersList.push('Vodafone')
                        } else if (carrier == 4) {
                            this.carriersList.push('Kore')
                        }
                    }
                    this.carriersList = this.carriersList.join(', ');

                    this.companyDetails.wallet.balance = this.companyDetails.wallet.balance.toFixed(2)

                    if (this.companyDetails.disabledAt != null) {
                        this.companyDetails.disabled = true
                    } else {
                        this.companyDetails.disabled = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('COLD_STOCK_ACCESS') > -1) {
                        this.companyDetails.hasColdStockAccess = true
                    } else {
                        this.companyDetails.hasColdStockAccess = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('TIER_2_INTERNATIONAL_ROAMING') > -1) {
                        this.companyDetails.tier2Roaming = true
                    } else {
                        this.companyDetails.tier2Roaming = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('VOICE_ACCESS') > -1) {
                        this.companyDetails.voiceAccess = true
                    } else {
                        this.companyDetails.voiceAccess = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('HOT_SPOT_PLANS_ACCESS') > -1) {
                        this.companyDetails.hotSpotAccess = true
                    } else {
                        this.companyDetails.hotSpotAccess = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('NB_IOT_PLANS_ACCESS') > -1) {
                        this.companyDetails.nbIoTPlans = true
                    } else {
                        this.companyDetails.nbIoTPlans = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('CAT_M1_PLANS_ACCESS') > -1) {
                        this.companyDetails.catM1Plans = true
                    } else {
                        this.companyDetails.catM1Plans = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('SALES_TAX_EXEMPT') > -1) {
                        this.companyDetails.excludeNYTax = true
                    } else {
                        this.companyDetails.excludeNYTax = false
                    }

                    if (this.companyDetails.companyPermissions.indexOf('NETCRACKER_ACTIVE_READY') > -1) {
                        this.companyDetails.suspendMRC = true
                    } else {
                        this.companyDetails.suspendMRC = false
                    }

                    this.selectedAccountType = this.companyDetails.wallet.mode
                    this.initialSelectedAccountType = this.companyDetails.wallet.mode

                    if (this.companyDetails.wallet.mode == 'PREPAID') {
                        this.displayedAccountType = 'Prepaid'
                    } else if (this.companyDetails.wallet.mode == 'OFFLINE_BILLING') {
                        this.displayedAccountType = 'Offline Billing'
                    } else if (this.companyDetails.wallet.mode == 'HYBRID_TERMS') {
                        this.displayedAccountType = 'Hybrid Terms ( - $' + Math.abs(this.companyDetails.wallet.hybridModeLimit).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' )'
                        this.hybridTermsLimit = Math.abs(this.companyDetails.wallet.hybridModeLimit)
                        this.initialHybridTermsLimit = Math.abs(this.companyDetails.wallet.hybridModeLimit)
                    }

                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Company Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        selectCarrier() {
            this.$refs['selectCarrier'].show()
        },
        showAddColdStock(carrierId) {
            this.carrierId = carrierId
            this.$refs['selectCarrier'].hide()
            this.coldStock = true;
        },
        loginCompany(id, name, typeAccount, hasColdStockAccess, tier2Roaming, voiceAccess, hotSpotAccess, nbIoTPlans, catM1, simonActiveReady, carriersList) {
            this.$session.set('companyId', id);
            this.$session.set('companyName', name);
            this.$session.set('typeAccount', typeAccount);
            this.$session.set('coldStockAccess', hasColdStockAccess);
            this.$session.set('tier2Roaming', tier2Roaming);
            this.$session.set('voiceAccess', voiceAccess);
            this.$session.set('hotSpotAccess', hotSpotAccess);
            this.$session.set('nbIoTPlans', nbIoTPlans);
            this.$session.set('catM1Plans', catM1);
            this.$session.set('simonActiveReady', simonActiveReady);
            if (carriersList.indexOf(1) > -1) {
                this.$session.set('simonCarrierAvailable', true)
            } else {
                this.$session.set('simonCarrierAvailable', false)
            }
            if (carriersList.indexOf(2) > -1) {
                this.$session.set('tmobileCarrierAvailable', true)
            } else {
                this.$session.set('tmobileCarrierAvailable', false)
            }
            if (carriersList.indexOf(3) > -1) {
                this.$session.set('vodafoneCarrierAvailable', true)
            } else {
                this.$session.set('vodafoneCarrierAvailable', false)
            }
            if (carriersList.indexOf(4) > -1) {
                this.$session.set('koreCarrierAvailable', true)
            } else {
                this.$session.set('koreCarrierAvailable', false)
            }
            this.$session.set('loggedFromList', false)
            this.$router.push("/dashboard");
        },
        backToCompanies() {
            this.$router.push('/admin/companies');
        },
        showDiscountModal() {
            this.$refs['discountModal'].show();
        },
        cancelDiscount() {
            this.$refs['discountModal'].hide();
            this.discount = this.initialDiscount;
        },
        getDiscount(companyId) {
            Axios.get(`${globalStore.data.restApiUrl}/billing-ng/wallet-info?companyId=${companyId}`)
                .then(response => {
                    this.discount = response.data.companyDiscount * 100;
                    this.initialDiscount = response.data.companyDiscount * 100;
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting discount error',
                        text: 'Something was wrong with getting discount on this company.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        saveDiscount() {
            let discountApi = this.discount / 100;
            Axios.patch(`${globalStore.data.restApiUrl}/billing-ng/wallet/discount?discount=${discountApi}&companyId=${this.companyId}`)
                .then(response => {
                    this.$refs['discountModal'].hide();
                    this.initialDiscount = this.discount;
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Discound assigned',
                        text: '-' + this.discount + '% discount has been assigned to ' + this.companyDetails.companyName + ' company!',
                        duration: 3000,
                    });
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Updating discount error',
                        text: 'Something was wrong with update discount on this company.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        changeDiscountValue(value) {
            this.discount = value;
        },
        getCarrierSettings() {
            Axios.get(`${globalStore.data.restApiUrl}/admin/company/get-properties?companyId=${this.companyId}`)
                .then(response => {
                    this.disallowEditCarrier = response.data;
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Something was wrong with getting company carrier settings.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        showCarriersModal(){
            if (this.companyDetails.nbIoTPlans) {
                this.initialNBIoT = true;
                this.NBIoTAvailable = true;
            } else {
                this.initialNBIoT = false;
                this.NBIoTAvailable = false;
            }
            if (this.companyDetails.catM1Plans) {
                this.initialCatM1PlansAvailable = true;
                this.catM1PlansAvailable = true;
            } else {
                this.initialCatM1PlansAvailable = false;
                this.catM1PlansAvailable = false;
            }
            if (this.companyDetails.tier2Roaming == true) {
                this.simonTier2RoamingAvailable = this.companyDetails.tier2Roaming;
                this.simonTier2RoamingInitial = true;
            } else {
                this.simonTier2RoamingAvailable = false;
                this.simonTier2RoamingInitial = false;
            }
            if (this.companyDetails.voiceAccess == true) {
                this.voiceAccessAvailable = this.companyDetails.voiceAccess;
                this.voiceAccessInitial = true;
            } else {
                this.voiceAccessAvailable = this.companyDetails.voiceAccess;
                this.voiceAccessInitial = false;
            }
            if (this.companyDetails.hotSpotAccess == true) {
                this.hotSpotAccessAvailable = this.companyDetails.hotSpotAccess;
                this.hotSpotAccessInitial = true;
            } else {
                this.hotSpotAccessAvailable = this.companyDetails.hotSpotAccess;
                this.hotSpotAccessInitial = false;
            }
            for (let carrier of this.companyDetails.displayedCarriers) {
                if (carrier == 1) {
                    this.simonCarrierAvailable = true;
                    this.initialSimonCarrier = true
                } else if (carrier == 2) {
                    this.tmobileCarrierAvailable = true;
                    this.initialTmobileCarrier = true
                } else if (carrier == 3) {
                    this.vodafoneCarrierAvailable = true;
                    this.initialVodafoneCarrier = true
                } else if (carrier == 4) {
                    this.koreCarrierAvailable = true;
                    this.initialKoreCarrier = true
                }
            }
            this.$refs['carrier-config'].show();
        },
        hideCarriersModal(){
            this.$refs['carrier-config'].hide();
        },
        revertCarrierConfig() {
            this.simonCarrierAvailable = false;
            this.tmobileCarrierAvailable = false;
            this.vodafoneCarrierAvailable = false;
            this.koreCarrierAvailable = false;
            for (let carrier of this.companyDetails.displayedCarriers) {
                if (carrier == 1) {
                    this.simonCarrierAvailable = true;
                } else if (carrier == 2) {
                    this.tmobileCarrierAvailable = true;
                } else if (carrier == 3) {
                    this.vodafoneCarrierAvailable = true;
                } else if (carrier == 4) {
                    this.koreCarrierAvailable = true;
                }
            }
            this.hideCarriersModal();
        },
        saveCarrierConfig() {
            let carrierConfig = {
                    "accesses": [],
                    "displayedCarriers": []
                };
            if (this.simonCarrierAvailable || this.tmobileCarrierAvailable || this.vodafoneCarrierAvailable || this.koreCarrierAvailable) {
                if (this.simonCarrierAvailable) {
                    carrierConfig.displayedCarriers.push(1)
                }

                if (this.tmobileCarrierAvailable) {
                    carrierConfig.displayedCarriers.push(2)
                }

                if (this.vodafoneCarrierAvailable) {
                    carrierConfig.displayedCarriers.push(3)
                }

                if (this.koreCarrierAvailable) {
                    carrierConfig.displayedCarriers.push(4)
                }

                if (this.simonTier2RoamingAvailable) {
                    carrierConfig.accesses.push({'permission': 'TIER_2_INTERNATIONAL_ROAMING', 'granted': true});
                } else {
                    carrierConfig.accesses.push({'permission': 'TIER_2_INTERNATIONAL_ROAMING', 'granted': false});
                }

                if (this.voiceAccessAvailable) {
                    carrierConfig.accesses.push({'permission': 'VOICE_ACCESS', 'granted': true});
                } else {
                    carrierConfig.accesses.push({'permission': 'VOICE_ACCESS', 'granted': false});
                }

                if (this.hotSpotAccessAvailable) {
                    carrierConfig.accesses.push({'permission': 'HOT_SPOT_PLANS_ACCESS', 'granted': true});
                } else {
                    carrierConfig.accesses.push({'permission': 'HOT_SPOT_PLANS_ACCESS', 'granted': false});
                }

                if (this.NBIoTAvailable) {
                    carrierConfig.accesses.push({'permission': 'NB_IOT_PLANS_ACCESS', 'granted': true});
                } else {
                    carrierConfig.accesses.push({'permission': 'NB_IOT_PLANS_ACCESS', 'granted': false});
                }

                if (this.catM1PlansAvailable) {
                    carrierConfig.accesses.push({'permission': 'CAT_M1_PLANS_ACCESS', 'granted': true});
                } else {
                    carrierConfig.accesses.push({'permission': 'CAT_M1_PLANS_ACCESS', 'granted': false});
                }

                Axios.patch(globalStore.data.restApiUrl + '/admin/accounts/set-accesses-and-disp-carriers?companyId=' + this.companyId, carrierConfig)
                    .then(response => {
                        this.getCompanyDetails(this.companyId);
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Carrier config saved.',
                            text: 'Now company will have displayed only selected carriers.',
                            duration: 5000,
                        });
                        this.hideCarriersModal()
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Carrier config not saved.',
                            text: 'Something went wrong during saving carriers config. Please, try again later.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } else {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Incorrect data',
                    text: 'At least one carrier must be selected for a company.',
                    duration: 5000,
                });
            }
        },
        getItems() {
            Axios.get(globalStore.data.restApiUrl + '/orders/items?companyId=' + this.companyId)
                .then(response => {
                    this.itemsList = []
                    this.initialPrices = []
                    for (let item of response.data) {
                        let tempItem = item;
                        let initialItemTemplate = {
                            id: item.id,
                            unitPrice: item.unitPrice.toFixed(2)
                        }
                        this.initialPrices.push(initialItemTemplate)

                        tempItem.initialPrice = item.unitPrice.toFixed(2);
                        tempItem.unitPrice = item.unitPrice.toFixed(2);
                        this.itemsList.push(tempItem)
                    }

                    this.$refs['productPricing'].show()
                })
            .catch(error => {
                console.log(error)
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Unable to get SIM prices',
                    text: 'We are unable to get data of SIM cards prices.',
                    duration: 5000,
                });
            })
        },
        productPricing() {
            this.getItems();
        },
        isPriceChanged() {
            let disable = true
            for (let current of this.itemsList) {
                for (let initial of this.initialPrices) {
                    if (current.id == initial.id) {
                        if (initial.unitPrice != null) {
                            if (initial.unitPrice != current.unitPrice) {
                                disable = false
                            }
                        } else {
                            if (current.unitPrice != null && current.unitPrice != '') {
                                disable = false
                            }
                        }
                    }
                }
            }
            return disable
        },
        cancelCustomPrices() {
            for (let item of this.itemsList) {
                item.unitPrice = item.initialPrice;
            }
            this.$refs['productPricing'].hide();
        },
        saveCustomPrices() {
            for (let item of this.itemsList) {
                if (item.unitPrice != item.initialPrice) {
                    if (item.initialPrice != null && (item.unitPrice == 0 || item.unitPrice == '' || item.unitPrice == null)) {
                        Axios.delete(`${globalStore.data.restApiUrl}/item-custom-pricing/item/${item.id}?companyId=${this.companyId}`)
                            .then(response => {
                                item.initialPrice = item.unitPrice
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Data has been removed from the database',
                                    text: 'Custom price of ' + item.carrier.carrierName + ' ' + item.type + ' has been removed.',
                                    duration: 5000,
                                });
                            })
                            .catch(error => {
                                item.unitPrice = item.initialPrice
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Data has not been removed in the database',
                                    text: 'Custom price of ' + item.carrier.carrierName + ' ' + item.type + ' has not been removed.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    } else {
                        Axios.post(`${globalStore.data.restApiUrl}/item-custom-pricing/item/${item.id}?price=${item.unitPrice}&companyId=${this.companyId}`)
                            .then(response => {
                                item.initialPrice = item.unitPrice
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Data has been changed in the database',
                                    text: 'Custom price of ' + item.carrier.carrierName + ' ' + item.type + ' has been changed.',
                                    duration: 5000,
                                });
                            })
                            .catch(error => {
                                item.unitPrice = item.initialPrice
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Data has not been changed in the database',
                                    text: 'Custom price of ' + item.carrier.carrierName + ' ' + item.type + ' has not been changed.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    }
                }
            }
            this.$refs['productPricing'].hide();
        },
        absValue(id) {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                for (let item of this.itemsList) {
                    if(item.id == id) {
                        item.unitPrice = Math.abs(item.unitPrice).toFixed(2);

                        return false
                    }
                }
            }, 500)
        },
        fixValue(id) {
            for (let item of this.itemsList) {
                if(item.id == id) {
                    item.unitPrice = Number(item.unitPrice).toFixed(2);
                    return false
                }
            }
        },
        disableAccount() {
            Axios.patch(`${globalStore.data.restApiUrl}/admin/accounts/company-disabled/${this.companyDetails.disabled}?companyId=${this.companyId}`)
                .then(response => {
                    if(this.companyDetails.disabled) {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Company disabled',
                            text: 'Now users will not be able to login to this company.',
                            duration: 5000,
                        });
                    } else {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Company enabled',
                            text: 'Now users will be able to login to this company.',
                            duration: 5000,
                        });
                    }
                })
                .catch(error => {
                    if(this.companyDetails.disabled) {
                        this.companyDetails.disabled = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Company not disabled',
                            text: 'Something went wrong during disabling company. Please try again later.',
                            duration: 5000,
                        });
                    } else {
                        this.companyDetails.disabled = true
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Company not enabled',
                            text: 'Something went wrong during enabling company. Please try again later.',
                            duration: 5000,
                        });
                    }
                    console.log(error)
                })
        },
        showTopUpModal() {
            this.$refs['topUpModal'].show();
            let today = new Date();
            this.topUp.paymentDate = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);
        },
        hideTopUpModal() {
            this.$refs['topUpModal'].hide();
        },
        savePlanTypes() {
            Axios.patch(globalStore.data.restApiUrl + '/admin/accounts/nb-iot-plans-access/' + this.initialNBIoT + '?companyId=' + this.companyId)
                .then(response => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'NB IoT Plan saved',
                        text: 'You successfully changed settings of plan types.',
                        duration: 5000,
                    });
                    this.companyDetails.nbIoTPlans = this.initialNBIoT;
                    this.$refs['planTypesModal'].hide();
                })
                .catch(error => {
                    console.log(error)
                })
        },
        showTopUpConfirmModal() {
            this.topUpErrors.amount = ''
            this.topUpErrors.date = ''
            let errorsCounter = 0;

            let regEx = /^\-?[0-9]\d*(?:\.\d{0,2})?$/;

            if (!regEx.test(this.topUp.amount)) {
                this.topUpErrors.amount = 'Invalid dollar amount'
                errorsCounter++;
            }

            if (this.topUp.amount <= 0 && this.topUp.paymentType != 'CHARGE') {
                this.topUpErrors.amount = 'You must type positive value of amount.'
                errorsCounter++;
            } else if (this.topUp.amount >= 0 && this.topUp.paymentType == 'CHARGE') {
                this.topUpErrors.amount = 'You must type negative value of amount.'
                errorsCounter++;
            }
            if (this.topUp.paymentDate == null || this.topUp.paymentDate == '') {
                this.topUpErrors.date = 'You must select date.'
                errorsCounter++;
            }
            if (errorsCounter != 0) {
                return false
            } else {
                this.hideTopUpModal();
                this.$refs['topUpConfirmModal'].show();
                this.topUpAmountDisplayed = Math.abs(Number(this.topUp.amount)).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
        },
        hideTopUpConfirmModal() {
            this.$refs['topUpConfirmModal'].hide();
        },
        sendTopUp() {
            let parsedData = null
            if (this.topUp.paymentType != 'PAYMENT') {
                parsedData = this.topUp
                delete parsedData.paymentSource
            }
            Axios.post( globalStore.data.restApiUrl + '/billing-pricing/no-cc-top-up?companyId=' + this.companyId, this.topUp )
            .then(response => {
                this.hideTopUpConfirmModal();
                if (this.topUp.paymentType != 'CHARGE') {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Funds added to ' + this.companyDetails.companyName,
                        text: 'Added $ ' + this.topUpAmountDisplayed + ' to ' + this.companyDetails.companyName,
                        duration: 5000,
                    });
                } else {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Funds charged from ' + this.companyDetails.companyName,
                        text: 'Charged $ ' + this.topUpAmountDisplayed + ' from ' + this.companyDetails.companyName,
                        duration: 5000,
                    });
                }
                this.topUp = {
                    amount: null,
                    paymentType: 'PAYMENT',
                    paymentSource: 'ACH',
                    paymentDate: null
                }
            })
            .catch(error => {
                if (this.topUp.paymentType != 'CHARGE') {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Error during adding funds',
                        text: 'Error has occured during adding funds. Please contact support.',
                        duration: 5000,
                    });
                } else {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Error during charging funds',
                        text: 'Error has occured during charging funds. Please contact support.',
                        duration: 5000,
                    });
                }
                console.log(error)
            })
        },
        getAuditLogs(resetPages) {
            this.loading = true
            this.noLogs = false
            if (resetPages) {
                this.sortSettings.page = 1
                this.getAuditLogsPagination();
            }
            Axios.get(`${globalStore.data.restApiUrl}/company-audit?companyId=${this.companyId}&size=${this.sortSettings.size}&page=${this.sortSettings.page}&desc=${this.sortSettings.desc}&sort=${this.sortSettings.sort}${this.filterQuery}${this.searchString}`)
                .then(response => {
                    this.auditLogs = response.data
                    if (this.auditLogs.length == 0) {
                        this.noLogs = true
                    }
                    this.loading = false
                })
                .catch(error => {
                    this.loading = false
                    console.log(error)
                })
        },
        getAuditLogsPagination() {
            Axios.get(`${globalStore.data.restApiUrl}/company-audit/page-count?companyId=${this.companyId}&size=${this.sortSettings.size}${this.filterQuery}${this.searchString}`)
                .then(response => {
                    this.paginationCount = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
        paginationControll(ev) {
            this.sortSettings.page = ev;
            this.getAuditLogs(false);
        },
        searchKeyUp() {
            clearTimeout(this.typingTimer)
            this.typingTimer = setTimeout(() => {
                this.searchRow()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.typingTimer)
        },
        searchRow: function () {
            this.searchString = '&search=' + this.search;
            this.getAuditLogs(true)
        },
        changesSort(ev) {
            this.sortSettings.sort = ev.target.getAttribute("aria-colindex");

            if (ev.target.getAttribute("aria-sort") == 'none') {
                document.querySelectorAll("table.table-managment thead th[aria-sort]").forEach(item => {
                    item.setAttribute("aria-sort", 'none')
                })
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettings.desc = false
            } else if (ev.target.getAttribute("aria-sort") == 'ascending') {
                ev.target.setAttribute("aria-sort", 'descending')
                this.sortSettings.desc = true
            } else if (ev.target.getAttribute("aria-sort") == 'descending') {
                ev.target.setAttribute("aria-sort", 'ascending')
                this.sortSettings.desc = false
            }
            this.getAuditLogs(false)
        },
        hideExportSelect() {
            this.$refs['fileFormatModal'].hide()
        },
        showExportSelect() {
            this.$refs['fileFormatModal'].show()
        },
        exportCsv() {
            this.$refs['fileFormatModal'].hide()

            Axios.get(globalStore.data.restApiUrl + "/company-audit/csv?companyId=" + this.companyId + this.filterQuery)
                .then(response => {
                    let csvContent = "data:text/csv;charset=utf-8," + response.data;
                    var fileLink = document.createElement('a');fileLink.href = csvContent;
                    fileLink.setAttribute('download', this.companyDetails.companyName + ' - Audit logs export.csv');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Company Audit log Export failed',
                    text: 'Something went wrong during Company Audit log Export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        exportXlsx() {
            this.$refs['fileFormatModal'].hide()

            Axios.get(globalStore.data.restApiUrl + "/company-audit/xlsx?companyId=" + this.companyId + this.filterQuery, {responseType: 'blob'})
                .then((response) => {
                    const fileLink = URL.createObjectURL(new Blob([response.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                        )
                    );
                    const link = document.createElement('a')
                    link.href = fileLink
                    link.setAttribute('download', this.companyDetails.companyName + ' - Audit logs export.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Company Audit log Export failed',
                    text: 'Something went wrong during Company Audit log Export. Please contact with support.',
                    duration: 3000,
                });
                console.log(error);
            });
        },
        filtersClick() {
            if (this.filtersShown == false) {
                this.filtersShown = true;
                this.setInitialAuditLogsFilters();
            }
        },
        setAuditLogsFilter() {
            this.filterQuery = ''
            this.auditLogsStartDateError = ''
            this.auditLogsEndDateError = ''
            if (this.auditLogsStartDate != '' || this.auditLogsEndDate != '') {
                if (this.auditLogsStartDate == '') {
                    this.auditLogsStartDateError = 'Start Date can not be empty'
                    return false
                }
                if (this.auditLogsEndDate == '') {
                    this.auditLogsEndDateError = 'Start Date can not be empty'
                    return false
                }

                if (this.auditLogsStartDate > this.auditLogsEndDate) {
                    this.auditLogsStartDateError = 'Start Date can not be later than End Date'
                    return false
                }

                this.filterQuery = '&applyTimeframeFiltering=true&startDate=' + this.auditLogsStartDate + '&endDate=' + this.auditLogsEndDate
            }

            if (this.auditLogsFilters.created) {
                this.filterQuery = this.filterQuery + '&modificationTypes=COMPANY_CREATED'
            }
            if (this.auditLogsFilters.pay) {
                this.filterQuery = this.filterQuery + '&modificationTypes=PAY_OPTION_MODIFICATION'
            }
            if (this.auditLogsFilters.carrier) {
                this.filterQuery = this.filterQuery + '&modificationTypes=CARRIER_MODIFIED'
            }
            if (this.auditLogsFilters.permission) {
                this.filterQuery = this.filterQuery + '&modificationTypes=COMPANY_PERMISSION_MODIFIED'
            }
            if (this.auditLogsFilters.productPricing) {
                this.filterQuery = this.filterQuery + '&modificationTypes=PRODUCT_PRICING_MODIFIED'
            }
            if (this.auditLogsFilters.disability) {
                this.filterQuery = this.filterQuery + '&modificationTypes=DISABILITY_MODIFIED'
            }
            if (this.auditLogsFilters.discount) {
                this.filterQuery = this.filterQuery + '&modificationTypes=DISCOUNT_MODIFIED'
            }
            if (this.auditLogsFilters.planOption) {
                this.filterQuery = this.filterQuery + '&modificationTypes=PLAN_OPTION_MODIFIED'
            }
            if (this.auditLogsFilters.planPricing) {
                this.filterQuery = this.filterQuery + '&modificationTypes=PLAN_PRICING_MODIFIED'
            }
            if (this.auditLogsFilters.SATopUp) {
                this.filterQuery = this.filterQuery + '&modificationTypes=SUPER_ADMIN_TOP_UP'
            }
            if (this.auditLogsFilters.customFields) {
                this.filterQuery = this.filterQuery + '&modificationTypes=CUSTOM_FIELDS_MODIFIED'
            }
            if (this.auditLogsFilters.tags) {
                this.filterQuery = this.filterQuery + '&modificationTypes=TAG_SETTINGS_MODIFIED'
            }
            if (this.auditLogsFilters.creditCard) {
                this.filterQuery = this.filterQuery + '&modificationTypes=CREDIT_CARD_SETTINGS_CHANGED'
            }
            if (this.auditLogsFilters.manualTopUp) {
                this.filterQuery = this.filterQuery + '&modificationTypes=MANUAL_TOP_UP'
            }
            if (this.auditLogsFilters.userCreated) {
                this.filterQuery = this.filterQuery + '&modificationTypes=USER_CREATED'
            }
            if (this.auditLogsFilters.userDisabled) {
                this.filterQuery = this.filterQuery + '&modificationTypes=USER_DISABLED'
            }
            if (this.auditLogsFilters.userModified) {
                this.filterQuery = this.filterQuery + '&modificationTypes=USER_MODIFIED'
            }
            this.setInitialAuditLogsFilters()
            this.getAuditLogs(true)
            this.filtersShown = false
        },
        clearAuditLogsFilters() {
            this.auditLogsStartDate = ''
            this.auditLogsEndDate = ''

            this.auditLogsFilters = {
                created: false,
                pay: false,
                carrier: false,
                permission: false,
                productPricing: false,
                disability: false,
                discount: false,
                planOption: false,
                planPricing: false,
                SATopUp: false,
                customFields: false,
                tags: false,
                creditCard: false,
                manualTopUp: false,
                userCreated: false,
                userDisabled: false,
                userModified: false
            }
        },
        setInitialAuditLogsFilters() {
            this.initialAuditLogsStartDate = this.auditLogsStartDate
            this.initialAuditLogsEndDate = this.auditLogsEndDate
            this.initialAuditLogsFilters.created = this.auditLogsFilters.created
            this.initialAuditLogsFilters.pay = this.auditLogsFilters.pay
            this.initialAuditLogsFilters.carrier = this.auditLogsFilters.carrier
            this.initialAuditLogsFilters.permission = this.auditLogsFilters.permission
            this.initialAuditLogsFilters.productPricing = this.auditLogsFilters.productPricing
            this.initialAuditLogsFilters.disability = this.auditLogsFilters.disability
            this.initialAuditLogsFilters.discount = this.auditLogsFilters.discount
            this.initialAuditLogsFilters.planOption = this.auditLogsFilters.planOption
            this.initialAuditLogsFilters.planPricing = this.auditLogsFilters.planPricing
            this.initialAuditLogsFilters.SATopUp = this.auditLogsFilters.SATopUp
            this.initialAuditLogsFilters.customFields = this.auditLogsFilters.customFields
            this.initialAuditLogsFilters.tags = this.auditLogsFilters.tags
            this.initialAuditLogsFilters.creditCard = this.auditLogsFilters.creditCard
            this.initialAuditLogsFilters.manualTopUp = this.auditLogsFilters.manualTopUp
            this.initialAuditLogsFilters.userCreated = this.auditLogsFilters.userCreated
            this.initialAuditLogsFilters.userDisabled = this.auditLogsFilters.userDisabled
            this.initialAuditLogsFilters.userModified = this.auditLogsFilters.userModified
        },
        cancelAuditLogsFilters () {
            this.auditLogsStartDate = this.initialAuditLogsStartDate
            this.auditLogsEndDate = this.initialAuditLogsEndDate
            this.auditLogsFilters.created = this.initialAuditLogsFilters.created
            this.auditLogsFilters.pay = this.initialAuditLogsFilters.pay
            this.auditLogsFilters.carrier = this.initialAuditLogsFilters.carrier
            this.auditLogsFilters.permission = this.initialAuditLogsFilters.permission
            this.auditLogsFilters.productPricing = this.initialAuditLogsFilters.productPricing
            this.auditLogsFilters.disability = this.initialAuditLogsFilters.disability
            this.auditLogsFilters.discount = this.initialAuditLogsFilters.discount
            this.auditLogsFilters.planOption = this.initialAuditLogsFilters.planOption
            this.auditLogsFilters.planPricing = this.initialAuditLogsFilters.planPricing
            this.auditLogsFilters.SATopUp = this.initialAuditLogsFilters.SATopUp
            this.auditLogsFilters.customFields = this.initialAuditLogsFilters.customFields
            this.auditLogsFilters.tags = this.initialAuditLogsFilters.tags
            this.auditLogsFilters.creditCard = this.initialAuditLogsFilters.creditCard
            this.auditLogsFilters.manualTopUp = this.initialAuditLogsFilters.manualTopUp
            this.auditLogsFilters.userCreated = this.initialAuditLogsFilters.userCreated
            this.auditLogsFilters.userDisabled = this.initialAuditLogsFilters.userDisabled
            this.auditLogsFilters.userModified = this.initialAuditLogsFilters.userModified
            this.filtersShown = false
        },
        selectAllFilters() {
            this.auditLogsFilters.created = true
            this.auditLogsFilters.pay = true
            this.auditLogsFilters.carrier = true
            this.auditLogsFilters.permission = true
            this.auditLogsFilters.productPricing = true
            this.auditLogsFilters.disability = true
            this.auditLogsFilters.discount = true
            this.auditLogsFilters.planOption = true
            this.auditLogsFilters.planPricing = true
            this.auditLogsFilters.SATopUp = true
            this.auditLogsFilters.customFields = true
            this.auditLogsFilters.tags = true
            this.auditLogsFilters.creditCard = true
            this.auditLogsFilters.manualTopUp = true
            this.auditLogsFilters.userCreated = true
            this.auditLogsFilters.userDisabled = true
            this.auditLogsFilters.userModified = true
        },
        deselectAllFilters() {
            this.auditLogsFilters.created = false
            this.auditLogsFilters.pay = false
            this.auditLogsFilters.carrier = false
            this.auditLogsFilters.permission = false
            this.auditLogsFilters.productPricing = false
            this.auditLogsFilters.disability = false
            this.auditLogsFilters.discount = false
            this.auditLogsFilters.planOption = false
            this.auditLogsFilters.planPricing = false
            this.auditLogsFilters.SATopUp = false
            this.auditLogsFilters.customFields = false
            this.auditLogsFilters.tags = false
            this.auditLogsFilters.creditCard = false
            this.auditLogsFilters.manualTopUp = false
            this.auditLogsFilters.userCreated = false
            this.auditLogsFilters.userDisabled = false
            this.auditLogsFilters.userModified = false
        },
        openSetOwnerModal(id, firstname, lastname) {
            this.newOwner.firstName = firstname
            this.newOwner.lastName = lastname
            this.newOwnerId = id
            this.$refs['ownerConfirm'].show()
        },
        closeSetOwnerModal() {
            this.$refs['ownerConfirm'].hide()
        },
        setAsOwner() {
            Axios.patch(globalStore.data.restApiUrl + '/admin/users/update-customer-owner?newOwnerId=' + this.newOwnerId + '&companyId=' + this.companyId)
                .then(() => {
                    this.getUsersCompany(this.companyId);
                    this.newOwnerMail = null
                    this.newOwnerId = null
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Owner changed',
                        text: 'New owner of ' + this.companyDetails.companyName + ' is ' + this.newOwner.firstName + ' ' + this.newOwner.lastName,
                        duration: 3000,
                    });
                    this.closeSetOwnerModal();
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Owner not changed',
                        text: 'Something went wrong during changing company owner. Please contact support',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        clickAffiliateProgram() {
            if (this.companyDetails.companyAffiliateInfo.approvedAffiliate) {
                this.openAffiliateWindow = true
            } else {
                this.showAffiliateProgramModal()
            }
        },
        clickMoveSims() {
            this.$router.push('/admin/company/' + this.companyId + '/move-sims')
        },
        showAffiliateProgramModal() {
            this.$refs['affiliateProgram'].show()
        },
        hideAffiliateProgramModal() {
            this.$refs['affiliateProgram'].hide()
        },
        changeAffiliate() {

        },
        saveAffiliateProgram() {
            let parsedData = {
                percentageGain: this.commisionSelected / 100
            }
            Axios.post(globalStore.data.restApiUrl + '/affiliate/admin?companyId=' + this.companyId, parsedData)
                .then(response => {
                    this.hideAffiliateProgramModal()
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Affiliate program enabled.',
                        text: this.companyDetails.companyName + ' has now affiliate program. To see its details, click Affiliate Program button once more.',
                        duration: 3000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Affiliate program not enabled.',
                        text: 'An error occured during enabling Affliate Program to ' + this.companyDetails.companyName + '. Please contact support',
                        duration: 3000,
                    });
                    console.log(error)
                })
        },
        selectCommisionValue(value) {
            this.commisionSelected = value
        }
    },
    created() {
        this.getCarrierSettings();
        this.companyId = this.$route.params.id
        this.getDiscount(this.companyId)
        this.getCompanyDetails(this.companyId)
        this.getUsersCompany(this.companyId, null)

        this.getAuditLogs(true);

        let permissions = []

        permissions = this.$session.get('saPermissions')

        if (permissions.indexOf('EDIT_COMPANY_ALLOWANCES') > -1) {
            this.allowancesEditAccess = true
        }

        if (permissions.indexOf('EDIT_COMPANY_PAY_SETTINGS') > -1) {
            this.paySettingsEditAccess = true
        }

        if (permissions.indexOf('EDIT_COMPANY_OTHER_SETTINGS') > -1) {
            this.otherSettingsEditAccess = true
        }

        if (permissions.indexOf('COLD_STOCK_MANAGEMENT') > -1) {
            this.SAColdStockManagement = true
        }

        if (permissions.indexOf('ORDER_MANAGEMENT') > -1) {
            this.orderManagementPermission = true
        }
    }
}
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
.company-details {
    .card-body {
        padding: 0;

        .header-bar {
            display: flex;
            justify-content: space-between;
            padding: 20px 0;
            border-bottom: 1px solid #F0F3F5;
            .left-side {
                display: flex;
                h3 {
                    font-size: 24px;
                    font-weight: 700;
                    padding-left: 20px;
                    margin-right: 18px;
                    margin-bottom: 0;
                }
                .disabled-info {
                    background-color: #fc4d4d;
                    color: #ffffff;
                    padding: 4px 16px;
                    -webkit-border-radius: 13px;
                    -moz-border-radius: 13px;
                    border-radius: 13px;
                }
            }
            i {
                padding-right: 20px;
                cursor: pointer;
            }
        }

        .upper {
            display: flex;
            flex-direction: column;
            height: calc(100vh - 244px);
            overflow: auto;

            .sidebar-client {
                padding: 0;
                border-right: 1px solid #F0F3F5;

                .sidebar-content {
                    display: flex;
                    height: 100%;
                }

                .boxhead {
                    h3 {
                        display: block;
                        padding: 0 0 20px 0;
                        margin: 20px 0 0;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }

                .client-data {
                    border-left: 1px solid #f0f3f5;
                    h4 {
                        padding: 10px 20px;
                        margin: 0 0 20px 0;
                        font-size: 15px;
                        background-color: #F0F3F5;
                    }
                    >div {
                        padding: 0 20px;
                        margin-bottom: 20px;

                        span {
                            display: block;
                            font-size: 14px;
                            line-height: 24px;
                        }

                        strong {
                            margin: 0;
                            font-size: 14px;
                            font-weight: 700;
                            line-height: 24px;
                        }

                        &.company {
                            span {
                                display: block;
                                font-size: 14px;
                                font-weight: 700;
                                line-height: 21px;
                            }
                        }

                        &.boxhead {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .allowances {
                border-top: 1px solid #F0F3F5;
                border-bottom: 1px solid #F0F3F5;
                .allowances-header {
                    padding: 20px 0 0 20px;
                    margin: 0;
                    font-size: 15px;
                    font-weight: 700;
                }
                .allowances-box {
                    display: flex;
                }
            }

            .account-details {
                display: grid;
                grid-row: 6;
                grid-column: 7;
                margin-top: 20px;
                .account-details-header {
                    grid-column-start: 1;
                    grid-column-end: 8;
                    grid-row-start: 1;
                    grid-row-end: 1;
                    margin: 0 0 20px;
                    padding: 0 20px;
                    h3 {
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
                .account-details-cell {
                    h5 {
                        font-size: 14px;
                        font-weight: 400;
                    }
                    &.carriers {
                        grid-column-start: 2;
                        grid-column-end: 1;
                        grid-row-start: 2;
                        grid-row-end: 2;
                        padding-left: 20px;
                    }
                    &.balance {
                        grid-column-start: 2;
                        grid-column-end: 2;
                        grid-row-start: 2;
                        grid-row-end: 2;
                    }
                    &.last-payment {
                        grid-column-start: 3;
                        grid-column-end: 3;
                        grid-row-start: 2;
                        grid-row-end: 2;
                    }
                    &.tac-executed {
                        grid-column-start: 4;
                        grid-column-end: 4;
                        grid-row-start: 2;
                        grid-row-end: 2;
                    }
                    &.account-type {
                        grid-column-start: 5;
                        grid-column-end: 5;
                        grid-row-start: 2;
                        grid-row-end: 2;
                    }
                    &.discount {
                        grid-column-start: 6;
                        grid-column-end: 6;
                        grid-row-start: 2;
                        grid-row-end: 2;
                    }
                    &.users-number {
                        grid-column-start: 7;
                        grid-column-end: 7;
                        grid-row-start: 2;
                        grid-row-end: 2;
                    }

                }

                .affiliate-program-header {
                    grid-column-start: 1;
                    grid-column-end: 8;
                    grid-row-start: 3;
                    grid-row-end: 3;
                    margin: 40px 0 20px;
                    padding: 0 20px;
                    font-size: 14px;
                    font-weight: 700;
                }

                .affiliate-program-property {
                    display: flex;
                    flex-direction: column;
                    grid-row-start: 4;
                    grid-row-end: 4;
                    font-size: 14px;
                    h5 {
                        font-size: 14px;
                        font-weight: 400;
                    }
                    &.on-program {
                        grid-column-start: 1;
                        grid-column-end: 2;
                        padding-left: 20px;
                    }
                    &.refferals {
                        grid-column-start: 2;
                        grid-column-end: 3;
                    }
                    &.commision {
                        grid-column-start: 3;
                        grid-column-end: 4;
                    }
                }

                .company-details-header {
                    grid-column-start: 1;
                    grid-column-end: 8;
                    grid-row-start: 5;
                    grid-row-end: 5;
                    margin: 20px 0;
                    padding: 20px 20px 0;
                    border-top: 1px solid #f0f3f5;
                    h3 {
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
                .company-details-cell {
                    h5 {
                        font-size: 14px;
                        font-weight: 400;
                    }
                    &.company-address {
                        display: flex;
                        flex-direction: column;
                        grid-column-start: 1;
                        grid-column-end: 1;
                        grid-row-start: 6;
                        grid-row-end: 6;
                        padding-left: 20px;
                    }

                    &.owner-name {
                        grid-column-start: 2;
                        grid-column-end: 2;
                        grid-row-start: 6;
                        grid-row-end: 6;
                    }

                    &.owner-email {
                        grid-column-start: 3;
                        grid-column-end: 3;
                        grid-row-start: 6;
                        grid-row-end: 6;
                    }

                    &.contact {
                        grid-column-start: 4;
                        grid-column-end: 4;
                        grid-row-start: 6;
                        grid-row-end: 6;
                    }

                    &.tax-id {
                        grid-column-start: 5;
                        grid-column-end: 5;
                        grid-row-start: 6;
                        grid-row-end: 6;
                    }
                }

            }

            .company-details {
                margin-top: 20px;
                .company-details-header {
                    margin-bottom: 20px;
                    padding: 0 20px;
                    h3 {
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
                .company-details-content {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 20px 20px;
                    border-bottom: 1px solid #F0F3F5;
                    .company-details-cell {
                        h5 {
                            font-size: 14px;
                            font-weight: 400;
                        }
                        .company-address {
                            display: flex;
                            flex-direction: column;
                        }
                    }
                }
            }

            .client-settings {
                padding: 20px 0 0;

                .boxhead {
                    padding-left: 20px;
                    margin-bottom: 12px;
                    h3 {
                        font-size: 15px;
                    }
                }

                .client-settings-buttons-box {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 20px;
                    .action-buttons-box {
                        display: flex;
                        flex-grow: 1;
                        flex-wrap: wrap;

                        .btn-planconfig,
                        .btn-carriersConfig,
                        .btn-selectcarrier,
                        .btn-productpricing,
                        .btn-companyconfig,
                        .btn-discount,
                        .btn-top-up,
                        .btn-plan-types,
                        .btn-affiliate-program {
                            padding-left: 19px;
                            padding-right: 19px;
                            background-color: #0088FF;
                            color: #fff;
                            font-size: 17px;
                            margin-right: 12px;
                            margin-bottom: 20px;

                            box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
                            text-align: left;
                            white-space: nowrap;

                            &:hover {
                                background-color: #0072cb;
                            }

                            @media (max-width: 1400px) {
                                margin-bottom: 12px;
                            }

                            i,
                            img {
                                margin-right: 17px;
                            }
                        }

                        .btn-plan-types {
                            display: flex;
                            align-items: center;
                        }

                        .btn-selectcarrier {
                            background-color: #0088FF;
                        }

                        .btn-discount {
                            margin-right: 10px;
                            background-color: #0088ff;
                            i {
                                -moz-transform:    scaleX(-1);
                                -o-transform:      scaleX(-1);
                                -webkit-transform: scaleX(-1);
                                transform:         scaleX(-1);

                                &:before {
                                    font-size: 18px;
                                }
                            }
                        }

                        .disable-account-box {
                            display: flex;
                            align-items: center;
                            margin-bottom: 20px;
                            margin-right: 50px;
                            label {
                                margin: 0 0 0 12px;
                            }
                        }

                        .btn-companyconfig {
                            background-color: #0088FF;
                        }
                    }
                    .login-button-box {
                        .btn-login-company {
                            display: flex;
                            flex-wrap: nowrap;
                            background-color: #00C4B0;
                            border-color: #00C4B0;
                            font-size: 14px;
                            font-weight: 700;
                            i {
                                margin-left: 12px;
                                font-size: 26px;
                                vertical-align: middle;
                            }
                        }
                    }
                }
            }

            .inner-client {
                margin-top: 20px;
                border-top: 1px solid #f0f3f5;
                padding: 20px 20px 0;
                h2 {
                    margin: 0 0 30px;
                    font-size: 15px;
                    font-weight: 700;
                }
                .control-and-legend {
                    display: flex;
                    align-items: center;
                    margin: 0 0 40px;
                    .show-disabled {
                        display: flex;
                        align-items: center;
                        margin: 0 60px 0 0;
                        .show-disabled-label {
                            margin-left: 10px;
                            font-weight: 400;
                        }
                    }
                    .legend {
                        display: flex;
                        .legend-item {
                            padding: 2px 4px;
                            margin: 0 8px 0 0;
                            -webkit-border-radius: 4px;
                            -moz-border-radius: 4px;
                            border-radius: 4px;
                            color: #fff;
                            text-transform: uppercase;
                            opacity: .5;
                            cursor: pointer;
                            &.active {
                                opacity: 1;
                            }
                            &.admin {
                                background-color: #FC4D4D;
                                border: 1px solid #D54040;
                            }
                            &.provisioning {
                                background-color: #C84DFC;
                                border: 1px solid #B343E2;
                            }
                            &.billing {
                                background-color: #747FE2;
                                border: 1px solid #5963B7;
                            }
                            &.customer-owner {
                                background-color: #000;
                                border: 1px solid #000;
                            }
                        }
                    }
                }
                .header-list-client {
                    display: flex;
                    justify-content: flex-start;
                    padding: 0 20px;
                    margin-bottom: 20px;

                    span {
                        font-weight: 700;
                        font-size: 15px;

                        &:nth-child(1) {
                            width: 40%;
                            max-width: 370px;
                        }

                        &:nth-child(2) {
                            width: 15%;
                            max-width: 370px;
                        }
                    }
                }

                .list-client {
                    .item {
                        padding: 20px;
                        margin-bottom: 20px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;

                        background-color: #F2F2F2;
                        border: 1px solid #C9CFD4;
                        border-radius: 5px;
                        &.disabled {
                            opacity: 0.5;
                        }

                        .user {
                            width: 40%;
                            max-width: 370px;

                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            .img-wrap {
                                margin-right: 20px;

                                .light-mode-img {
                                    display: block;
                                }
                                .dark-mode-img {
                                    display: none;
                                }
                            }

                            .data-wrap {
                                display: flex;
                                flex-direction: column;

                                strong {
                                    font-size: 15px;
                                    font-weight: 700;
                                    color: #2F353A;
                                }

                                span {
                                    font-size: 10px;
                                    font-weight: 400;
                                    color: #2F353A;
                                }
                            }
                        }

                        .home-company-role {
                            width: 15%;
                            max-width: 370px;
                            .role {
                                span {
                                    padding: 4px 27px;
                                    border-radius: 12px;

                                    font-size: 12px;
                                    line-height: 20px;
                                    color: #fff;
                                    background-color: #fff;

                                    &.Administrator {
                                        background-color: #FC4D4D;
                                    }

                                    &.Provisioning,
                                    &.Fulfilment {
                                        background-color: #C84DFC;
                                    }

                                    &.Billing {
                                        background-color: #747FE2;
                                    }

                                    &.Super {
                                        background-color: #B20000;
                                    }

                                    &.Owner {
                                        background-color: #000;
                                    }

                                    &.Support {
                                        background-color: #7B4DFC;
                                    }
                                }
                            }
                        }

                        .companies-roles {
                            display: flex;
                            align-items: center;
                            .role {
                                margin: 0 6px 0 0;
                                padding: 2px 4px;
                                border-radius: 4px;

                                font-size: 14px;
                                line-height: 17px;
                                color: #fff;
                                background-color: #fff;

                                &.admin {
                                    background-color: #FC4D4D;
                                    border: 1px solid #D54040;
                                }

                                &.provisioning {
                                    background-color: #C84DFC;
                                    border: 1px solid #B343E2;
                                }

                                &.billing {
                                    background-color: #747FE2;
                                    border: 1px solid #5963B7;
                                }

                                &.customer-owner {
                                    background-color: #000;
                                    border: 1px solid #000;
                                }

                                .fa-home {
                                    margin: 0 6px 0 0;
                                    font-size: 16px;
                                    color: #fff;
                                }
                            }
                        }

                        .premission {
                            width: 45%;
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            .item {
                                padding: 5px 33px;
                                margin: 0 10px 0 0;

                                background-color: #3A4149;
                                background-image: url("../../assets/img/check-roles.png");
                                background-repeat: no-repeat;
                                background-position: 5px center;
                                font-size: 14px;
                                line-height: 24px;
                                color: #fff;
                            }
                        }
                        .make-owner-box {
                            flex-grow: 1;
                            display: flex;
                            justify-content: flex-end;
                            .make-owner {
                                font-size: 15px;
                                text-transform: uppercase;
                                color: #0088FF;
                                font-weight: 700;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
            .audit-log-table {
                position: relative;
                border: 0;
                overflow: visible;
                .filter-row {
                    display: block;
                    .table-title {
                        margin: 20px 20px 0;
                        font-size: 15px;
                    }
                    .filters {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        padding: 20px 20px 0;
                        .left-side {
                            display: flex;
                            .filters-btn-box {
                                position: relative;
                                margin: 0 0 0 20px;
                                .filters-btn {
                                    white-space: nowrap;
                                }
                                .filters-box {
                                    position: absolute;
                                    top: calc(100% + 10px);
                                    left: calc(100% + 10px);
                                    display: flex;
                                    flex-direction: column;
                                    width: 966px;
                                    background-color: #fff;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;
                                    box-shadow: 0px 3px 20px #00000029;
                                    z-index: 10;
                                    .content-part {
                                        display: flex;
                                        .left-side {
                                            display: block;
                                            padding: 20px;
                                            border-right: 1px solid #C9CFD4;
                                            h3 {
                                                margin: 0 0 16px;
                                                font-size: 15px;
                                                font-weight: 700;
                                            }
                                            .date-pickers-box {
                                                display: flex;
                                                flex-wrap: nowrap;
                                                .date-picker-box {
                                                    position: relative;
                                                    display: flex;
                                                    flex-direction: column;
                                                    margin: 0 15px 0 0;
                                                    padding: 0 0 12px;
                                                    &:last-child {
                                                        margin: 0;
                                                    }

                                                    .date-label {
                                                        margin: 0 0 4px;
                                                        font-size: 12px;
                                                    }

                                                    .mx-datepicker {
                                                        width: 150px;
                                                    }

                                                    .error-msg {
                                                        position: absolute;
                                                        left: 0;
                                                        bottom: 0;
                                                        font-size: 10px;
                                                        color: #fc4d4d;
                                                        white-space: nowrap;
                                                    }
                                                }
                                            }
                                        }
                                        .right-side {
                                            display: block;
                                            width: 100%;
                                            padding: 20px;
                                            .header-and-check {
                                                display: flex;
                                                justify-content: space-between;
                                                margin: 0 0 16px;
                                                h3 {
                                                    font-size: 15px;
                                                    font-weight: 700;
                                                }
                                                a {
                                                    font-size: 15px;
                                                    color: #00b1ff;
                                                    text-transform: uppercase;
                                                    font-weight: 700;
                                                    cursor: pointer;
                                                }
                                            }
                                            .filters-checkboxes {
                                                display: flex;
                                                flex-direction: column;
                                                flex-wrap: wrap;
                                                max-height: 340px;
                                                .FTScheckbox {
                                                    width: 50%;
                                                }
                                            }
                                        }
                                    }
                                    .control-bar {
                                        display: flex;
                                        justify-content: space-between;
                                        padding: 12px 20px;
                                        border: 0;
                                        background-color: #f9f9f9;
                                        .right-side {
                                            .btn-primary {
                                                margin: 0 0 0 20px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .right-side {
                            display: flex;
                            align-items: center;
                            .export-audit-logs-btn {
                                margin: 0 20px 0 0;
                                white-space: nowrap;
                            }
                            label {
                                margin: 0 8px 0 0;
                            }
                        }
                    }
                }
                .table-company-log {
                    margin: 0 0 20px;
                    tbody {
                        tr {
                            td {
                                &:nth-child(1) {
                                    width: 15%;
                                }
                                &:nth-child(2) {
                                    width: 20%;
                                }
                                &:nth-child(3) {
                                    width: 25%;
                                }
                                &:nth-child(4) {
                                    width: 12.5%;
                                }
                                &:nth-child(5) {
                                    width: 12.5%;
                                }
                                &:nth-child(6) {
                                    width: 15%;
                                }
                            }
                        }
                    }
                }
                .audit-logs-pagination {
                    justify-content: center;
                }
                .loader-audit-logs-list {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .sk-wave {
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }

                    .text {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
                .no-logs {
                    position: absolute;
                    top: 100px;
                    right: 0;
                    bottom: 0;
                    left: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .sk-wave {
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }

                    .text {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
            }
        }
    }
}

#selectCarrierCompany___BV_modal_header_ {
    padding-bottom: 0;
}

#selectCarrierCompany___BV_modal_body_ {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    padding-top: 0;
    padding-bottom: 40px;

    .fts-icon-sim {
        margin-top: 6px;
        margin-bottom: 14px;
        &:before {
            color: #0075ff;
            font-size: 20px;
        }
    }

    strong {
        margin-bottom: 18px;
        font-size: 15px;
        line-height: 20px;
    }

    p {
        font-size: 14px;
        line-height: 24px;
    }

    .select-carrier-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .carrier-option {
            opacity: .6;

            &:hover {
                opacity: 1;
            }

            label {
                display: flex;
                justify-content: center;
                align-content: center;
                align-items: center;
                width: 190px;
                padding: 4px 20px;
                border: 1px solid #c9cfd4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                margin-right: 20px;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 40px;
                    margin: 0;
                    cursor: pointer;
                }
            }


        }
    }
}



#productPricing___BV_modal_header_ {
    padding-bottom: 0;
}

#productPricing___BV_modal_body_ {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    padding: 0 20px 20px;

    img {
        max-width: 16px;
        margin-bottom: 12px;
    }

    strong {
        margin-bottom: 18px;
        font-size: 15px;
        line-height: 20px;
    }

    p {
        margin-bottom: 26px;
        font-size: 14px;
        line-height: 24px;
    }

    .pricing-row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;

        .left-side {
            display: flex;
            flex-direction: row;
            align-items: center;

            .carrier-sim {
                height: 50px;
                width: auto;
                margin-right: 40px;
                max-width: none;
                margin-bottom: 0;
            }

            .carrier-logo-box {
                margin-right: 40px;
                .carrier-logo {
                    height: 32px;
                    width: auto;
                    max-width: 100%;
                    margin-bottom: 0;

                    &.light-mode {
                        display: block;
                    }
                    &.dark-mode {
                        display: none;
                    }
                    &.lower {
                        height: 24px;
                    }
                }
            }
        }

        .pricing-input {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            padding: 4px 0 4px 10px;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            background-color: #f0f3f5;
            input {
                max-width: 60px;
                border: none;
                margin-left: 4px;
                background-color: #f0f3f5;
                &:focus {
                    outline: none;
                }
            }
        }
    }

    .btns-box {
        .btn {
            width: 80px;
        }
        .custom-save-btn {
            margin-left: 10px;
        }
    }
}

.dark-theme {
    #affiliateProgram___BV_modal_body_ {
        .switch-row {
            border-color: #1a1c1d;
        }
        .commision {
            .rates-box {
                .rate {
                    border-color: #1a1c1d;
                }
            }
        }
    }

    #productPricing___BV_modal_body_ {
        .pricing-row {

            .carrier-logo-box {
                .carrier-logo {
                    &.light-mode {
                        display: none;
                    }
                    &.dark-mode {
                        display: block;
                    }
                }
            }

            .pricing-input {
                border: 1px solid #1d1f20;
                background-color: #515b65;

                span {
                    color: #fff;
                }

                input {
                    color: #fff;
                    background-color: #515b65;
                }
            }
        }
    }
}

#discountModal___BV_modal_body_ {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;

    .fa-tag {
        -moz-transform: scaleX(-1);
        -o-transform: scaleX(-1);
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
        &:before {
            color: #0088ff;
            font-size: 32px;
            margin-bottom: 8px;
        }
    }

    .close-discount-modal {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }

    strong {
        margin-bottom: 20px;
    }

    p {
        margin-bottom: 8px;
    }

    .discounts {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .discount-picker {
            width: 70px;
            margin-right: 8px;
            margin-bottom: 8px;
            padding: 5px 10px;
            border: 1px solid #C9CFD4;
            text-align: center;
            cursor: pointer;

            &:hover {
                border-color: #0088ff;
            }

            &.picked {
                border-color: #0088ff;
                background-color: #0088ff;
                color: #ffffff;
            }
        }
    }

    .discount-control-bar {
        display: flex;

        .btn {
            width: 80px;
            text-align: center;
            margin: 20px 10px 0;
        }
    }
}
#carrierConfig {
    .modal-dialog {
        max-width: 390px;
    }
}
#carrierConfig___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    .fa-close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }

    .fa-cubes {
        margin-top: 6px;
        margin-bottom: 14px;
        &:before {
            color: #0075ff;
            font-size: 20px;
        }
    }
    h3 {
        font-size: 16px;
        margin-bottom: 8px;
    }
    h5 {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: 400;
    }
    .carriers-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 0 20px 0;
        .carrier-box {
            padding: 0;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-start;
            padding: 0 20px;
            box-shadow: none;
            border-top: 1px solid #C9CFD4;

            &:last-child {
                border-bottom: 1px solid #C9CFD4;
            }

            .field {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 20px 0;
                width: 100%;

                .permission-switch {
                    padding: 0;
                    border: 0;
                }
            }
            label {
                margin-bottom: 0;
                margin-right: 20px !important;
                .carrier {
                    display: flex;
                    justify-content: flex-start;
                    align-content: flex-start;
                    align-items: center;
                    width: 120px;
                    border-radius: 5px;
                    margin-right: 20px;
                    cursor: pointer;

                    &.selected {
                        opacity: 1;
                    }

                    &.not-selected {
                        opacity: 0.4;
                    }

                    &:hover {
                        opacity: 1;
                    }

                    img {
                        width: auto;
                        height: 24px;
                        max-height: 24px;
                        margin: 0;
                        &.dark-mode {
                            display: none;
                        }
                        &.light-mode {
                            display: block;
                        }
                    }

                    .nb-iot-label {
                        margin: 0 0 0 10px;
                        padding: 3px 7px;
                        background-color: #8ac8ff;
                        white-space: nowrap;
                        font-weight: 700;
                    }
                    .cat-m1-label {
                        margin: 0 0 0 10px;
                        padding: 3px 7px;
                        background-color: #ffc400;
                        white-space: nowrap;
                        font-weight: 700;
                    }
                }
            }
        }
    }
    .carrier-config-control-bar {
        display: flex;
        justify-content: center;
        width: 100%;
        .btn {
            margin-left: 10px;
            &:first-child {
                margin: 0;
            }
        }
    }
}

#topUpModal___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 60px;
    .close-icon {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
    }
    .top-up-modal-icon {
        color: #0088FF;
        font-size: 22px;
        margin-bottom: 11px;
    }
    h3 {
        margin: 0 0 20px;
        font-size: 15px;
        font-weight: 700;
    }
    .top-up-amount-box {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        p {
            margin: 0 0 12px;
            font-size: 14px;
            font-weight: 400;
        }

        .enter-top-up-amount {
            width: 100%;
            padding: 8px 6px 8px 12px;
            border: 1px solid #C9CFD4;
            background-color: #f0f3f5;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            margin-bottom: 20px;

            &::placeholder {
                color: #F0F3F5;
            }

            &:focus {
                outline: none;
            }

        }
        .error-top-up {
            position: absolute;
            bottom: 5px;
            left: 0;
            font-size: 12px;
            color: #fc4d4d;
        }
        .top-up-hint {
            position: absolute;
            bottom: 5px;
            left: 0;
            font-size: 12px;
        }
    }

    .select-payment-type {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 20px;

        .custom-control-inline {
            padding-bottom: 10px;


            input[type="radio"] {
                display: none;

                &:checked + label::after {
                    content: '';
                    position: absolute;
                    left: 4px;
                    top: 8px;
                    width: 8px;
                    height: 8px;
                    background-color: #2F353A;
                    border-radius: 50%;
                }
                &[disabled="disabled"] {
                    &+label {
                        &:before {
                            opacity: 0.5;
                        }
                    }
                }
            }

            label {
                position: relative;
                cursor: pointer;
                margin: 0;
                padding-left: 40px;

                &::before {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 4px;
                    width: 16px;
                    height: 16px;
                    border: 2px solid #2F353A;
                    border-radius: 50%;
                    background-color: #fff;
                }

                &::after {
                    background-image: none;
                }
            }
        }
        .custom-select {
            &[disabled="disabled"] {
                opacity: 0.5;
            }
        }
    }
    .payment-date {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 20px;
        .error-top-up {
            position: absolute;
            bottom: -15px;
            left: 0;
            font-size: 12px;
            color: #fc4d4d;
        }
    }
    .control-bar-top-up {
        display: flex;
        justify-content: center;
        .btn {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

#topUpConfirmModal___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 60px;
    .close-icon {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
    }
    .top-up-modal-icon {
        color: #0088FF;
        font-size: 22px;
        margin-bottom: 11px;
    }
    p {
        max-width: 300px;
        text-align: center;
    }
    .control-bar-confirm-top-up {
        display: flex;
        .btn {
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

#planTypesModal___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 60px;
    .close-icon {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
    }
    img {
        margin-bottom: 8px;
    }
    h3 {
        margin-bottom: 18px;
        font-size: 15px;
    }
    h4 {
        margin-bottom: 24px;
        font-size: 14px;
        color: #515B65;
    }

    .plan-types {
        display: flex;
        flex-direction: column;
        label {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            margin: 0 0 20px;
            cursor: pointer;
            &.disabled {
                opacity: 0.4;
            }
            input {
                display: none;
                &+.checkbox-check {
                    position: relative;
                    margin: 0 20px 0 0;
                    line-height: 12px;
                    &:after {
                        content: '';
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        border: 1px solid #3A4149;
                        -webkit-border-radius: 2px;
                        -moz-border-radius: 2px;
                        border-radius: 2px;
                    }
                }

                &:checked {
                    &+.checkbox-check {
                        &:before {
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            display: inline-block;
                            content: '\f00c';
                            font-family: FontAwesome;
                            text-align: center;
                            font-size: 12px;
                            line-height: 16px;
                        }
                    }
                }
            }
            .plan-type {
                width: 190px;
                padding: 11px 0;
                text-align: center;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                font-size: 15px;
                font-weight: 700;
                user-select: none;
            }
        }
    }
    .buttons-row {
        .btn {
            width: 70px;
            &:first-child {
                margin-right: 8px;
            }
        }
    }
}


#payOptions___BV_modal_content_ {
    text-align: center;
    header {
        padding-bottom: 0;

        button {
            z-index: 2090;
        }
    }
    .modal-body {
        margin-top: -10px;
        padding-top: 0;

        i {
            margin-bottom: 15px;
            font-size: 20px;
            color: #0088FF;
        }

        h3 {
            margin: 0;
            margin-bottom: 18px;
            font-size: 15px;
            line-height: 18px;
            font-weight: 700;
        }

        h4 {
            margin: 0;
            margin-bottom: 10px;
            font-size: 14px;
            line-height: 24px;
        }

        .options {
            text-align: left;
            padding: 0 24px;

            .custom-control {
                display: block;
                margin-bottom: 21px;
                &.hybrid-radio {
                    margin-bottom: 11px;
                }
            }
            .hybrid-terms-input-box {
                position: relative;
                margin-bottom: 20px;
                h6 {
                    margin: 0 0 5px;
                    color: #515B65;
                    font-size: 12px;
                }

                .input-negative-dollars {
                    display: flex;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: space-between;
                    width: 150px;
                    padding: 8px 6px 8px 12px;
                    border: 1px solid #dadfe2;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    background-color: #f0f3f5;
                    span {
                        white-space: nowrap;
                    }
                    input {
                        flex-grow: 1;
                        max-width: 110px;
                        background-color: #f0f3f5;
                        border: none;
                        &:focus {
                            outline: none;
                        }
                    }
                }
                .error-payment-method {
                    position: absolute;
                    bottom: -15px;
                    left: 0;
                    font-size: 12px;
                    color: #fc4d4d;
                }
            }

        }

        .buttons {
            display: flex;
            justify-content: center;

            button {
                margin-left: 10px;
            }
        }
    }
}



#fileFormatModal___BV_modal_header_ {
    padding-bottom: 0;
}

#fileFormatModal___BV_modal_body_ {
    padding-top: 0;
    .file-format-popup {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        padding: 0 20px 20px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }

        .close-icon {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
        }
    }
}

#affiliateProgram___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    .close-icon {
        position: absolute;
        top: 25px;
        right: 25px;
        cursor: pointer;
    }
    .fa-pie-chart {
        margin: 25px 0 20px;
        color: #0088ff;
        font-size: 20px;
    }
    h3 {
        margin: 0 0 20px;
        font-size: 15px;
        font-weight: 700;
    }
    p {
        max-width: 360px;
        margin: 0 0 20px;
        text-align: center;
        font-size: 14px;
        line-height: 24px;
    }
    .switch-row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0 16px;
        padding: 20px 0;
        border-top: 1px solid #c9cfd4;
        border-bottom: 1px solid #c9cfd4;
        label {
            margin: 0 0 0 20px;
        }
    }
    .commision {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .rates-box {
            display: flex;
            margin: 0 0 30px;
            .rate {
                padding: 8px 20px;
                margin: 0 8px 0 0;
                border: 1px solid #C9CFD4;
                cursor: pointer;
                &:last-child {
                    margin: 0;
                }
                &.selected,
                &:hover {
                    color: #fff;
                    background-color: #0088ff;
                }
            }
        }
    }
    .control-row {
        display: flex;
        justify-content: center;
        margin: 0 0 20px;
        .btn-success {
            margin: 0 0 0 10px;
        }
    }
}

#ownerConfirm___BV_modal_body_ {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .fa-close {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
    img {
        width: 20px;
        height: 20px;
        margin: 0 0 14px;
    }
    h3 {
        margin: 0 0 18px;
        font-size: 15px;
        font-weight: 700;
    }
    p {
        max-width: 420px;
        text-align: center;
    }
    .buttons-row {
        display: flex;
        .btn-light {
            margin-right: 10px;
        }
    }
}

.dark-theme {
    .company-details {
        .card-body {

            .header-bar {
                border-color: #2f353a;
            }

            .upper {
                .sidebar-client {
                    border-right-color: #2f353a;
                    .client-data {
                        border-color: #2f353a;
                        h4 {
                            background-color: #2f353a;
                        }
                    }
                }
                .content-client {
                    .inner-client {
                        .list-client {
                            border-color: #1a1c1d;
                            .item {
                                background-color: #2f353a;
                                border-color: #1a1c1d;
                                .user {
                                    .img-wrap {
                                        .light-mode-img {
                                            display: none;
                                        }
                                        .dark-mode-img {
                                            display: block;
                                        }
                                    }
                                    .data-wrap {
                                        strong,
                                        span {
                                            color: #edeeef;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .audit-log-table {
                    .filter-row {
                        border-bottom: 0;
                        .filters {
                            .left-side {
                                .filters-btn-box {
                                    .filters-box {
                                        background-color: #3a4149;
                                        color: #fff;
                                        .content-part {
                                            .left-side {
                                                border-color: #1a1c1d;
                                            }
                                        }
                                        .control-bar {
                                            background-color: #2f353a;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .allowances {
                    border-color: #1a1c1d;
                    .allowances-box {
                        border-color: #1a1c1d;
                    }
                }
                .account-details {
                    .company-details-header {
                        border-color: #1a1c1d;
                    }
                }
                .inner-client {
                    border-color: #1a1c1d;
                    .list-client {
                        .item {
                            background-color: #515b65;
                            border-color: #1a1c1d;
                            .user {
                                .img-wrap {
                                    .light-mode-img {
                                        display: none;
                                    }
                                    .dark-mode-img {
                                        display: block;
                                    }
                                }
                                .data-wrap {
                                    strong,
                                    span {
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                }
            }


            .audit-log-table {
                .loader-audit-logs-list {
                    background-color: rgba(0,0,0,0.4);
                }
                .filter-row {
                    .filters {
                        .left-side {
                            .search-box {
                                -webkit-border-radius: 5px;
                                -moz-border-radius: 5px;
                                border-radius: 5px;
                                .form-control {
                                    border: none;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    .modal-header {
        button {
            color: #fff;
        }
    }
    .modal-content {
        background-color: #3a4149;
        color: #edeeef;
        .carrier-option {
            .light-mode {
                display: none;
            }
            .dark-mode {
                display: block;
            }
        }
    }

    #carrierConfig___BV_modal_body_ {
        .carriers-box {
            .carrier-box {
                label {
                    .carrier {
                        .dark-mode {
                            display: block;
                        }
                        .light-mode {
                            display: none;
                        }
                    }
                }
            }
        }
    }


    #topUpModal___BV_modal_body_ {
        .top-up-amount-box {
            .enter-top-up-amount {
                background-color: #515b65;
                border: 1px solid #1d1f20;
                color: #fff;
            }
        }
    }

    #payOptions___BV_modal_content_ {
        .options {
            .hybrid-terms-input-box {
                h6 {
                    color: #ffffff;
                }
                .input-negative-dollars {
                    background-color: #515b65;
                    border: 1px solid #1d1f20;
                    input {
                        background-color: #515b65;
                        color: #fff;
                    }
                }
            }
        }
    }
}


.permission-switch,
.enable-add-colstock {
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    .switch {
        margin-right: 10px !important;
    }
    label {
        cursor: pointer;
        margin: 0;
    }
}

</style>
